export default {
  welcome: "Welcome",
  request_processing: "Your request has been received and is being processed...",
  start_typing_or_select: "Start typing or select from the list...",
  download: "Download",
  toc: "Contents",
  view: "View",
  find: "Search",
  compact: "Compact",
  full: "Full",
  message_sent: "Message sent",
  more: "Details",
  order_group_search: "Order business reference",
  logout_counter_message: 'Session ends in 5 minutes, press "cancel" to cancel',
  password_expires_in_3_days_title: "Your password expires in 3 days",
  password_expires_in_3_days_text:
    "For security reasons you have to change your password once in 30 days. Your password expires in 3 days. Change your password in the personal account section",
  password_expired_text:
    "For security reasons you have to change your password once in 30 days. Your password has expired. Change password now.",
  cancel: "Cancel",
  close: "Close",
  history: "History",
  confirm: "Confirm Action",
  confirm_translation: "Would you like to translate keyword?",
  "email-confirmed":
    "E-mail is confirmed. Use it and a password you've set during registration to login",
  yes: "Yes",
  no: "No",
  add: "Add",
  save: "Save",
  back: "Back",
  select: "Select by Parameters",
  save_and_sign: "Save and Sign",
  save_and_send: "Save and Send",
  send: "Send",
  delete: "Delete",
  deselect: "Hide",
  ok: "Ok",
  readmore: "Show more",
  unreadmore: "Hide",
  collapse: "Collapse",
  expand: "Expand",
  wait: "Loading in progress. Please don't close the window",
  tnved_code: "HS Code code",
  tnved_name: "HS Code",
  validate: "Validation",
  validate_contract: "Contract validation",
  validate_full: "Full validation",
  export_xml: "Export to XML",
  export_pdf: "Export to PDF",
  validate_success: "Validation was successful",

  error: "Error when saving. Try again",
  "errors-at-tab": "Errors in the folder",
  "errors-dialog-title": "Errors in the document",
  "errors-dialog":
    "Errors in the Document. Unable to save the data. Correct errors in the folders marked below and try to save the data again.",

  message: {
    "invite-ok": "Invitations sent successfully",
    "registration-successfull": "Registration is successful",
    "login-successfull": "Authorisation is successful",
    "login-unsuccessfull": "Authorisation is unsuccessful",
    "contract-created": "Contract registered successfully",
    "contract-not-created": "Contract hasn't been registered",
    "invoice-created": "Invoice registered successfully",
    "invoice-not-created": "Invoice hasn't been registered",
    "specification-created": "Specification registered successfully",
    "specification-not-created": "Specification hasn't been registered",
    "formm-created": "Form-M registered successfully",
    "formm-not-created": "Form-M hasn't been registered",
    "packaging-created": "Packing List registered successfully",
    "packaging-not-created": "Packing List hasn't been registered",

    "cmr-created": "CMR registered successfully",
    "cmr-not-created": "CMR hasn't been registered",
    "fm1-created": "FM1 registered successfully",
    "fm1-not-created": "FM1 hasn't been registered",
    "epi-created": "EPD registered successfully",
    "epi-not-created": "EPD hasn't been registered",
    "awb-created": "AWB registered successfully",
    "awb-not-created": "AWB hasn't been registered",
    "ktg-ok": "Railway Bill registered successfully",
    "ktg-nok": "Railway Bill hasn't been registered",
    "decline_delivery_offer-ok": "Offer  rejected",
    "decline_delivery_offer-nok": "Request hasn't been registered",
    "decline_broker_offer-ok": "Offer rejected",
    "decline_broker_offer-nok": "Request hasn't been registered",
    "create-delivery_offer-nok": "Offer hasn't been registered",
    "select-delivery_offer-nok": "Request hasn't been registered",
    "delivery_offer-ok": "Offer registered successfully",
    "create-delivery_offer-ok": "Registered successfully",
    "select-delivery_offer-ok": "Request registered successfully",
    "create-broker_offer-ok": "Registered successfully",
    "create-broker_offer-nok": "Offer hasn't been registered",
    "broker_offer-ok": "Offer accepted",
    "broker_offer-nok": "Request hasn't been registered",
    "select-broker_offer-ok": "Request registered successfully",
    "select-broker_offer-nok": "Request hasn't been registered",
    astana_1_ok: "XML file registered successfully",
    astana_1_nok: "XMP file hasn't been registered",
    d_selector_ok: "XLSX file registered successfully",
    d_selector_nok: "XLSX file hasn't been registered",
    wsdl_astana_1_ok: "Request sent successfully",
    wsdl_astana_1_nok: "Request hasn't been registered",
    ktzh_sftp_ok: "Request sent successfully",
    ktzh_sftp_nok: "Request hasn't been registered",
    contract_signed: "Contract signed successfully",
    contract_not_signed: "Not signed. Try again",
    document_signature_is_wrong:
      "Wrong signature. The Document is changed or not signed yet",
    document_signature_is_ok: "Signature is correct. Paper copy created",
    document_signed: "Signature is correct. Paper copy created",
    document_not_signed: "Document signed successfully",
    "save_pa_doc-ok": "Document is saved successfully",
    "save_pa_doc-nok": "Document is not saved",
    "update_pa_doc-ok": "Ducoment is updated successfully",
    "update_pa_doc-nok": "Document is not updated",
    "remove_pa_doc-ok": "Document is removed successfully",
    "remove_pa_doc-nok": "Document is not removed",
    signature_no_contragent:
      "You can not sign the contract. No contragent selected!",

    success: "Operation completed successfully",
    no_success: "Failed to complete operation",
    "rwb-created": "Railway bill saved successfully",
    "rwb-not-created": "Failed to save rail waybill",
    "insurance-created": "Insurance saved successfully",
    "insurance-not-created": "Failed to save insurance",
    signature_bin_is_not_found:
      "No BIN was found for your signature. Use a different signature",
    signature_bin_is_not_valid:
      "The BIN of your signature does not match. Use a different signature",
    "offer-created": "Offer created successfully",
    "offer-not-created": "Offer is not created",
    "offer-deleted": "Offer deleted successfully",
    "offer-not-deleted": "Offer is not deleted",

    login_request_not_approved:
      "Your registration request has not yet been verified",
    login_user_not_found: "User not found",
    login_user_blocked: "the user is blocked",
    login_verification_needed: "Verification is needed",
    login_wrong_credentials: "Wrong login or password",
    login_ecp_invalid: "Invalid EDS",
    ktg_attorney_created: "KTZ Power of attorney is created successfully",
    ktg_attorney_not_created: "KTZ Power of attorney is not created",
    account_balance_is_low: "Your current account balance is {balance}. Please take action to avoid any interruptions.",
  },
  notifications: {
    empty: "No Notifications",
    showall: "Show All Notifications",
    notifications_title: "Notifications",
    view_title: "View Notification",
    type_1_title: "Offer received for the Application No {{ObjectId}}",
    type_1_text:
      "Dear {{OrgName}} , You have received an Offer from  {{CreatorName}} for your Application",
    type_2_title:
      "Notification of admission to the proposal for the Application No. {{ObjectId}}",
    type_2_text:
      "Dear  {{OrgName}}, you have received Request on your Application from  {{CreatorName}}",
    type_3_title:
      "Contract approval notification on the Aplication No{{ObjectId}}",
    type_3_text:
      "Dear {{OrgName}}, you have received the Contract approval on your Application from  {{CreatorName}}",
    type_4_title: "Deal participation notification",
    type_4_text:
      "Dear {{OrgName}}, you have received an acceptance from  {{CreatorName}} on your Application to participate in the Deal",
    type_5_title: "Deal participation declining notification",
    type_5_text:
      "Dear {{OrgName}}, you have received a declining from  {{CreatorName}} on your Application to participate in the Deal",
    type_6_title:
      "Invitation for goods transportation upon the Application No {{ObjectId}}",
    type_6_text:
      "Dear {{OrgName}}, You have received an Offer for goods transportation from  {{CreatorName}}",
    type_7_title:
      "Goods transportation acceptance on Appication No {{ObjectId}}",
    type_7_text:
      "Dear {{OrgName}}, your Application for goods transportation accepted by {{CreatorName}}",
    type_8_title:
      "Goods transportation declining for Application No {{ObjectId}}",
    type_8_text:
      "Dear {{OrgName}}, your Application for goods transportation declined by {{CreatorName}} .",
    type_9_title: "Carrier selection for Application No {{ObjectId}}",
    type_9_text:
      "Dear {{OrgName}}, Your company selected for goods delivery by {{CreatorName}}.",
    type_10_title: "Offer to Customs Broker upon Application No {{ObjectId}}",
    type_10_text:
      "Dear {{OrgName}}, You have received an Offer for customs brokerage services from {{CreatorName}}",
    type_11_title: "Customs Broker selection for Application No {{ObjectId}}",
    type_11_text:
      "Dear {{OrgName}}, Your company selected for customs brokerage services by {{CreatorName}}",
    type_12_title:
      "Customs brokerage services acceptance on Appication No {{ObjectId}}",
    type_12_text:
      "Dear {{OrgName}}, your Application for customos brokerage services accepted by {{CreatorName}} .",
    type_13_title:
      "Customs brokerage services declining for Application No {{ObjectId}}",
    type_13_text:
      "Dear {{OrgName}}, your Application for customs brokerage services declined by {{CreatorName}} ",
    type_14_title: "Customs Broker selection for Application No {{ObjectId}}",
    type_14_text:
      "Dear {{OrgName}}, Your company selected for customs brokerage services by {{CreatorName}}",

    type_15_title: "Signing a deal",
    type_15_text:
      "Dear {{OrgName}}, Your Application has been signed by {{CreatorName}} link to the Application",
    type_16_title: "New registration request",
    type_16_text:
      "Hello administrator, we've got a new registration request. Please review it in the Registrations section.",
    type_26_title: "Respond on Application No {{ObjectId}}",
    type_26_text:
      "Dear {{OrgName}}, you have received a Respond on your Application from  {{CreatorName}}",
    type_30_title: "New preliminary contract from the importer / agent",
    type_30_text:
      "Dear {{OrgName}}. There is a new preliminary contract from the importer / agent.",
    type_31_title: "Form M has been created",
    type_31_text: "Dear {{OrgName}}. Form M has been successfully created.",
    type_32_title: "The status of Form M has been changed",
    type_32_text: "Dear {{OrgName}}. Form M status has been changed.",
    type_33_title: "Form M has been registered in the system",
    type_33_text:
      "Dear {{OrgName}}. Form M (PAAR) has been registered in the system.",

    contragent: "Counterparty",
    offer: "Offer",
    courieroffer: "Offer for goods transportation",
    contract: "Contract",
    CreatorName: "From",
    OrgName: "To",
    Title: "Subject",
    CreationDate: "Date",
    perPage: "Show By",
  },
  education: {
    videos: "Videos",
    manuals: "Manuals",
    examples: "Examples",
    links: "Useful links",
    choose_category: "Select category",
  },
  menu: {
    business_note_history: "Business reference history",
    partner_search_history: "Partner search history",
    all_records: "All records",
    ca_history: "Business partner monitoring and verification history",
    home: "Home",
    back_to_home: "Back to homepage",
    customers: `For Customers`,
    partners: `For Partners`,
    events: `Events`,
    about: `About`,
    project: `About the Project`,
    board: `The Board`,
    services: `Services`,
    contacts: `Contacts`,
    signin: `Sign In`,
    register: `Sign Up`,
    find_partner: "Partner Search",
    find_person: "Person Search",
    risk_control: "Risk Control",
    business_score: "Business Score",
    company_historical_sales: "Company Historical Sales",
    case_filling_info: "Case Filling Information",
    find_partner_410: "Partner Search with ratings",
    orders: "Contracts",
    deals: "Deals",
    archive: "Archive",
    account: "My Account",
    logout: "Sign Out",
    twh: "Twh",
    comply_advantage: "KYC",
    company_information: "Company Information",

    monitoring: "Business partner monitoring and verification",
    business_note: "Business reference",
    education: "Education",
    ask_a_question: "Have a question?",
    short_search: "Short business reference",
  },
  account: {
    atb_info: "Customers of ATB get 3000 rubles upon registration",
    balance: "Balance",
    topup_account: "Topup balance",
    clientstatus: "Customer status",
    tarif: "standard",
    atb: "ATB customer",
    topup: "Get an invoice",
    admin_history_action_description: "Запрос",
    admin_history_action_created_by: "Email",

    balance: "Balance",
    topup_account: "Topup balance",
    topup_amount: "Amount",
    you_have: "Your balance: ",
    not_enough_funds_message:
      "You have insufficient balance. Request cannot be sent.",
    operation_history: "Operations history",
    history_action_description: "Operation description",

    bin: "Company ID",
    "company-country": "Registration Country",
    iin: "Personal ID",
    dob: "Birth Date",
    gender: "Gender",
    male: "Male",
    female: "Female",
    "user-section": "User",
    "company-section": "Company",
    edit_profile: "Edit Account",
    change_password: "Change Password",
    contracts: "My Contracts",
    offers: "My Applications",
    residency: "Residency",
    phone: "Phone",
    email: "e-Mail",
    position: "Position",
    address: "Address",
    old_password: "Existing Password",
    old_password_wrong: "Wrong Existing Password",
    insecure_new_password:
      "The Password has to consist of at least one number and one symbol",
    short_new_password: "The Password has to consist of 8 characters",
    new_password: "New Password",
    confirm_password: "Confirm Password",
    fill_all_fields: "Complete All Fields",
    passwords_not_equal:
      "New Password and Confirmed Password values don't match",
    accounts_of_company: "Company Bank Accounts",
    documents_of_company: "Documents",
    addresses_of_company: "Company Addresses",
    founders_of_company: "Company Shareholders",
    socials: "Social Networks",
    org_name: "Company Title",
    org_custom_code: "Company Customs ID",
    org_type: "Company Type",
    company_website: "Web-site",
    country: "Registration Country",
    bank: "Bank",
    account: "Bank Account",
    currency: "Account Currency",
    is_open: "Active",
    add_bank: "Add Bank",
    save_bank: "Save Bank",
    org_founders_person_name: "Shareholder Full Name",
    org_founders_company: "Sharehoder Company Title",
    org_founders_share: "Equity",
    org_founders_country: "Residency",
    add_founder: "Add Shareholder",
    save_founder: "Save Shareholder",
    jur_address: "Legal Address",
    post_address: "Correspondence Address",
    fact_address: "Actual Address",
    post_addr_country: "Country",
    index: "ZIP Code",
    region: "Region",
    district: "District",
    town: "City",
    city: "Locality",
    street: "Street",
    house: "Building No",
    room: "Office No",
    number: "e-Mail or Phone",
    org_oked: "Business Activity Code",

    company_contacts: "Contacts",
    org_reg_date: "Initial Registration Date",
    org_reregdate: "Last Legal Updates",
    company_status: "Company Status",
    company_filials: "Branches (if any)",
    company_ceo: "СEO info",
    company_ceo_date: "CEO Appointment Date",
    organization_networks: "Social Networks",

    org_is_broker: "Customs Broker",
    org_is_carrier: "Carrier",
    org_is_bank: "Bank",

    kpved: "Business Activity Spheres'",
    address_clone: "Copy from legal address",
    document_number: "Document Number",
    document_serial: "Document Series",
    document_date: "Document Date",
    document_issued_by: "Issued by",
    document_active: "Active",
    document_exp_date: "Document Expiration Date",
    add_document: "Save document",
    update_document: "Update document",
    signatures: "Signatures",
    cert_installed: "Signing certificate installed",
    cert_start_date: "Certificate validity date",
    end_start_date: "Certificate expiration date",
    add_new_cert: "Add new certificate",
    change_signature:
      "You are about to change your electronic signature. The old signature will no longer be valid. Are you sure?",
    signature_is_not_valid_yet:
      "The signing certificate is not yet valid and cannot be installed",
    signature_is_already_not_valid:
      "The signing certificate has expired and cannot be installed",
    pa_oferta: "Contract offer",
    pdf_aml: "Company check",

    insurance_requests: "Insurance requests",
    ceo_name: "Full name of the head",
    status: "Application status",
    statute: "Charter",
    registration_certificate: "Certificate of state registration",
    signature_right_certificate:
      "Order / document for the right to sign for the Head",
    ceo_passport: "Identity card/passport of the Head",
    insurance_request_certificate: "Insurance certificate",
    insurance_request_insurer_message: "Denial reason message",
    insurance_request_status_returned: "Returned by the insurer for revision",
    insurance_request_status_new: "New",
    insurance_request_status_approved: "Approved",
    insurance_request_status_: "New",
    add_insurance_requests: "Add insurance request",
    contract: "Contract",
    org_is_insurer: "The organization is an insurer",

    offer_group_mine: "Mine",
    offer_group_for_me: "For me",
    amount: "Amount",
    date_time: "Date/time",
    insurance_type: "Application type",
    insurance_type_6: "Cargo insurance",
    insurance_type_7: "Liability insurance",

    add_insurance_requests: "Add insurance request",
    contract: "Contract",

    transport_requests: "Transport requests",
    broker_requests: "Broker requests",
    insurance_requests: "Insurance requests",
    insurers_list: "Insurance companies",
    insurers_list_empty:
      "No insurance company has responded to your request yet",
    insurers_list_insurer_name: "Insurance agent",
    insurers_list_insurer_orgname: "Страховая компания",
    insurers_list_insurer_message: "Comments",
    insurers_list_insurer_status: "Status",
    insurers_list_insurer_price_franchise: "Price and franchise",
    insurers_list_insurer_select: "Choose and sign",
    insurers_list_insurer_sign: "Sign",
    edit_insurance_request: "Changing an insurance claim",
    or_upload_new: "or upload a new one",

    insurers_list_insurer_select_status: "Status",
    insurers_list_insurer_select_status_0: "Not chosen",
    insurers_list_insurer_select_status_1: "Chosen",
    insurer_submit_details: "Send offer details",
    insurance_price: "Contract price",
    insurance_franchise: "Franchise",
    insurance_submit: "Submit an offer",

    insurance_request_signed: "Insurance claim signed",
    add_insurance_contract_details:
      "Specify the details of the insurance offer",

    offer_requests: "Requests",
    offers_full: "Offers",

    pre_contracts: "Pre-contracts",

    topup_step: "Step",
    topup_step_1_title: "Enter amount",
    topup_step_2_title: "Get invoice",
    topup_step_3_title: "Pay invoice",
    topup_step_4_title:
      "Wait the funds to get to your balance (up to 2 business days)",
    topup_step_5_title: "Back to account",

    topup_history: "Topup history",

    topup_history_operation: "Topup/deduct",
    topup_history_service: "Service",

    team_id: "#",
    team_email: "E-mail",
    team_phone: "Phone",
    team_position: "Position",
    team_first_name: "First name",
    team_last_name: "Last name",
    team_password: "Temporary password",
    team: "Users",
    team_remove_confirm: "Are you sure you want to disable this user?",
    team_active_confirm: "Are you sure you want to activate this user?",
    team_add_user: "Add user",
    team_edit_user: "Change user",
    is_privileged: "Privileged",

    team_status: "Status",
    team_status_active: "Active",
    team_status_inactive: "Inactive",
    team_analytics_total: "Total users",

    analytics_ca_clicks: "Monitoring clicks",
    analytics_ca_cost: "Monitoring cost",
    analytics_search_clicks: "Searches clicks (rated)",
    analytics_search_cost: "Searches cost (rated)",
    analytics_search_clicks: "Searches clicks (simple)",
    analytics_search_cost: "Searches cost (simple)",
    analytics_note_clicks: "Notes clicks",
    analytics_note_cost: "Notes cost",

    data_tab: "User Details",
    topup_tab: "Top-up Account",
    logins_tab: "Logins Log",
    administration_tab: "Administration",
    analytics_tab: "Users Analytics",
    download_history: "Download history",
    users: "Users",

    current_password: "Input your current password",
    new_password: "Create a new password",
    repeat_new_password: "Repeat your new password",

    help_account: "Help with personal account",
    help_account_line_1:
      "To search, you need to enter the name (or a fragment of the name) of a legal entity or the name of an individual in English or Russian.",
    help_account_line_2:
      "All search results are stored in history. You can access the saved results for both review and printing.",
    help_account_line_3:
      "Here you can set up free monitoring on request. That will allow you to automatically track changes in the information of the checked object, and receive appropriate notifications about changes in your personal account.",
    demo_mode: "Demo mode",
  },
  home_slider: {
    header: `Trans-border e-trade platform `,
    subheader: `China, Russia, Kazakhstan, Central Asia, EU and Africa`,
  },
  home_adv: {
    base_title: `Base`,
    base_text: `Building on proven implemented solutions `,
    standards_title: `Standards`,
    standards_text: `Incorporating world-class standards for global implementation`,
    workflow_tilte: `Workflow`,
    workflow_text: `Complete cross-border e-document integrity `,
    integration_title: `Integration`,
    integration_text: `Integration of all foreign trade players, state and financial authorities`,
    scale_title: `Scale`,
    scale_text: `Common inter state transit & settlements system`,
  },
  title: {
    news: `Last Events`,
  },
  reg_form: {
    email_login_place: "Input your login",
    password_place: "Input your password",
    title: `Registration Form`,
    title_wf: `Registration`,
    egrul: "Load data from EGR YuL",
    kompra: `Load data from stat.gov.kz`,
    customer_data: `Customer data`,
    customer_id: `Type national ID`,
    customer_last_name: `Type last name`,
    customer_first_name: `Type name`,
    customer_middlename: `Type surname (if exists)`,
    customer_email: `Type e-mail`,
    customer_password: `Type temporary password`,
    customer_password_placeholder: `At least 8 characters. Has to consist of numbers, letters and punctuation marks`,
    customer_birthdate: `Birth date`,
    customer_address: "Residential address",
    customer_position: "Position",
    customer_phone: "Phone",
    customer_gender: `Gender`,
    customer_male: `Male`,
    customer_female: `Female`,
    company_data: `Company data`,
    company_id: `Type company national ID`,
    company_id_ru: "Type national ID",
    customer_id_ru: "Type company national ID",
    company_title: `Type company title`,
    company_regdate: "Company registration date",
    company_status: "Company status",
    company_reregdate: "Latest registration updates date",
    company_oked: "Business activity code",
    company_oked_code: "Business activity code",
    secondary_company_oked: "Business Supplementary  Activity Code",
    secondary_company_oked_code: "Business Suplementary Activity",
    company_contacts: "Contacts (if exists)",
    company_region: "Province",
    company_main_sphere: "Major business activity type",
    company_additional_sphere:
      "Supplementary business activity type (if exists)",
    company_filials: "Branches (if exist)",
    company_ceo: "Head",
    company_ceo_date: "Head appointment date",
    company_founder: "Shareholder data",
    company_number_of_founders: "Shareholders quantity",
    company_social_networks: "Internet communities",
    company_website: "Website",
    company_address: `Company legal address`,
    company_accept: `I accept public <a target="_blank" class="text-dark text-underline" href="[[offer_link]]">offer</a> agreement`,
    policy_accept: `I accept <a target="_blank" class="text-dark text-underline" href="[[policy_link]]">privacy policy</a>`,
    submit_button: `Submit application`,

    inn_placeholder: `Define company code`,
    company_name_placeholder: `Define company name`,
    company_address_placeholder: `Define legal address of company`,
    position: `Position`,
    position_placeholder: `Define position in the company`,
    last_name: `Last name`,
    last_name_placeholder: `Define the last name of representative of the company`,
    first_name: `First name`,
    first_name_placeholder: `Define first name`,
    phone: `Phone`,
    password_placeholder: `Set temporary password`,
    password: "Password",
    position_placeholder_user: `Define position of user in company`,
    last_name_placeholder_user: `Define last name of user`,
    first_name_placeholder_user: `Define first name of user`,
    email_login: "E-mail / Login",
  },
  login_form: {
    title_wf: "Sign in to your account",
    ecp_login: "Sign In with e-Sign",
    ecp_type: "e-Key Storage Type",
    submit_button: "Sign in",
    password: "Password",
    email: "E-mail / Login",
    ecp_login: "Sign in with EDS",
    ecp_NONE: "Select type",
    ecp_PKCS12: "Your Computer",
    ecp_AKKaztokenStore: "Kaztoken",
    ecp_AKKZIDCardStore: "Personal Identity",
    ecp_type: "Key storage type",
    forgot_password: "Forgot your password?",
    forgot_password_button: "Generate new password",
    forgot_password_description:
      "A link to generate a new password will be sent to the mail",
    forgot_email_sent:
      "Check your email, an email with a link to reset your password has been sent.",
    forgot_email_not_sent: "No such user was found or an error occurred.",
    reset_password_button: "Change password",
    reset_password: "Set new password",
    reset_password_description:
      "Set a new password for your account (enter your E-mail and new password)",
    reset_password_success_description:
      "The new password is successfully saved",
    reset_password_success: "Password changed",
    time_to_logout_description: "Session expired. You need to login again.",
    time_to_logout_title: "Session expired",
  },

  errors: {
    required: "This field is required",
    integer: "Input only digits",
    alpha: "Input only alpha characters",
    min_length: "Minimal length is 12 characters",
    max_length: "Maximal length is 12 characters",
    email: "Input correct E-mail",
    url: "Input correct URL",
    password:
      "Password must contain at least 1 digit and one special character",
  },
  aml: {
    aka: "Other Titles",
    fields: "Areas",
    media: "Media",
    keywords: "Key Words",
    key_data: "Key data",
    show_full: "View full listing",
    field_name: "Title",
    field_source: "Source",
    field_value: "Value",
    noresults: "No Results",
    countries: "Countries",
    DOB: "Date of birth",
    adverse_media_subtype: "Adverse media subtypes",
    related_url: "Related URL",
    created_at: "Created at",
    other_info: "Other information",
    associates: "Associate",

    full_name: "Full name",
    entity_type: "Entuty type",
    listing: "Listing",
    additional_listings: "Additional data",

    currently_on: "Currently On",
    removed_from: "Removed From",
    ended_at: "Removed at",
  },
  contracts: {
    search_by_number: "Search by number",
    search_by_number_button: "Search",
    paper_copy: "Paper copies",
    paper_copy_no_logo: "Paper copies (No logo)",
    paper_copy_proxy_ktzh: "KTZ Power of Attorney",
    paper_copy_proxy_ktzh_no_logo: "KTZ Power of Attorney (No logo)",
    paper_copy_invoice: "Invoice",
    paper_copy_invoice_no_logo: "Invoice (No logo)",
    paper_copy_cmr: "CMR",
    paper_copy_cmr_no_logo: "CMR (No logo)",
    paper_copy_contract: "Contract",
    paper_copy_contract_no_logo: "Contract (No logo)",
    upload: "Upload",
    customs_organs: "Customs Authorities",
    customs_xml_astana_1: "XML ASTANA 1",
    customs_xml_astana_1_title:
      "Download XML of Contract {contract_id} for upload to ASTANA1",
    make_xml_file: "Create XML file",
    customs_xlsx_d_selector: "XLSX D-Sector",
    customs_xlsx_d_selector_title:
      "Download data of Contract {contract_id} for D-Sector TS application software",
    make_xlsx_file: "Create XLSX file",
    customs_wsdl_astana: "WSDL ASTANA1",
    customs_wsdl_astana_title: "ASTANA1 Web Service. Contract {contract_id}",
    send_data_to_astana_1: "Send data to  ASTANA1",
    astana_1_answer: "ASTANA1 Response",
    transport_organs: "Carriers",
    transport_ktzh: "KTZ",
    transport_ktzh_title:
      "Data Exchange with KTZ for Contract No {contract_id}",
    transport_ktzh_make_title: "KTZ Data Request for Contract No {contract_id}",
    transport_ktzh_view_title: "KTZ Request View for Contract No {contract_id}",
    transport_ktzh_view_resp_title:
      "KTZ Response View for Contract No {contract_id}",
    ktzh_log_id: "№ п/п",
    ktzh_log_type: "Request/Response",
    ktzh_log_date: "Date",
    ktzh_log_file: "File",
    ktzh_log_action: "View",
    make_ktzh_request: "Data Request to KTZ",
    ktzh_for_date: "By date",
    ktzh_bin: "Company ID",
    ktzh_movement_type: "Message Type",
    ktzh_participant_type: "Participant Type",
    ktzh_expeditor_code: "Freight Forwarder Code",
    ktzh_send_request: "Send Request to sftp",

    ktzh_invoice_un: "Unique ID",
    ktzh_invoice_num: "Shipment Number",
    ktzh_recive_station_code: "Departure station code",
    ktzh_dest_station_code: "Destination station code",
    ktzh_sender_exp_no:
      "12-digit Sender Code, in priority, Sender Export Code if exists",
    ktzh_etsng_code: "Cargo Code by ЕТСНГ",
    ktzh_fact_mass: "Wagon Capacity",
    ktzh_payer_code: "Payer Code in  SAP",
    ktzh_vag_no: "Wagon No",
    ktzh_vag_count: "Number of Wagons  in the Shipment",
    ktzh_gruz: "Cargo Weight (Fact)",
    ktzh_invc_dt: "Transportation Acceptance Date",
    ktzh_container_no: "Container No",
    ktzh_smgs_type: "Interstate Transportation Type",

    transport_auto: "Road Transport",
    transport_avia: "Aviation Transport",
    transport_water: "Sea Transport",
    governmental_organs: "State Authorities",
    governmental_organs_tax: "Kazakhstan Tax Authorities",
    governmental_organs_certification: "Certification Authorities",
    governmental_organs_fin_monitoring: "AML Compliance State Authority",
    governmental_organs_customs: "Border Control Service",
    governmental_organs_make_choise: "Select",

    exim: "ExpImp",
    brokers_tab: "Customs Brokers",
    broker: "Customs Broker",
    choose_broker: "Customs Broker Selection",
    epi_price: "EPD Cost",
    td_price: "TD Cost",
    broker_request_modal_title:
      "Customs Brokerage Services Application for Contract No",
    broker_request: "Customs Brokerage Service Request",
    select_broker: "Select Customs Broker",
    epi_price_currency: "Currency",
    td_price_currency: "Currency",
    delivery_term: "Delivery Terms",
    brokers: "Customs Brokers",
    couriers_tab: "Transportation",
    view: "View",
    delivery_price: "Delivery Cost",
    delivery_date: "Delivery Date",
    offer_date: "Offer Date",
    choose_courier: "Carrier selection",
    delivery_request: "Delivery Application",
    select_courier: "Select Carrier",
    delivery_request_modal_title: "Delivery offers for the Contract No",
    delivery_request_from: "From",
    delivery_type: "Delivery Type",
    delivery_type_auto: "Road Transport",
    delivery_type_railway: "Rail Ways",
    delivery_type_avia: "Aviation",
    delivery_type_sea: "Sea Transport",
    delivery_type_post: "Mail",
    from_address: "Depart from",
    to_address: "Arrive at",
    weight: "Weight, brutto",
    volume: "Capacity",
    delivery_price_currency: "Currency",
    date_of_load: "Loading Date",
    date_of_delivery: "Delivery Date",
    packaging: "Package",
    hazard_class: "Hazard classification",
    hazard_class0: "Not hazard Cargo",
    hazard_class1: "Class 1: Explosive substances and articles",
    hazard_class2: "Class 2: Gases",
    hazard_class3: "Class 3: Flammable liquids",
    hazard_class4:
      "Class 4: Flammable solids, self-reactive substances and solid desensitized explosives",
    hazard_class5: "Class 5: Oxidizing substances",
    hazard_class6: "Class 6: Poisonous and infectious substances",
    hazard_class7: "Class 7: Radioactive materials",
    hazard_class8: "Class 8: Corrosive substances",
    hazard_class9: "Class 9: Other dangerous substances and articles",
    comments: "Notes",
    couriers: "Carriers",
    couriers_attahments_info:
      "New attachments will be saved when saving the Offer",
    courier_name: "Title",
    courier_code: "Code",
    invite: "Invite",

    offer_from: "The Offer from",
    offers_show_declined: "Show rejected Offers",
    offer_no_changes: "Offer to sign the Contract without corrections",
    offer_no_changes_message:
      "Sending this Offer you automatically sign the Contract with your e-signature. In case the Contract initiator accepts your Offer the Deal is  registered.",
    submit_ktg: "KTZ",
    attachements: "Attachments",
    add_attachement: "Add Attachment",
    add_attachement_info:
      "New Attachments will be saved when saving the Contract",
    "close-contract":
      "Changes will be lost. Are you sure to close the Contract?",
    filter_contracts: "Filter Contracts",
    number: "Number",
    title: "Subject",
    amount: "Amount",
    date: "Date",
    owner: "Owner",
    contragent: "Counterparty",
    currency: "Currency",
    new: "Create",
    add_form: "Create New Contract",
    contract_tab: "Contract",
    contragents_tab: "Counterparties",
    offers_tab: "Offers",
    contract_status: "Contract Status",
    status_1: "Application",
    status_2: "Sign Deal",
    status_3: "Deal",
    status_4: "Not Actual",
    type: "Contract Type",
    case: "Form of Contract",
    type_buy: "Buy",
    type_sell: "Sell",
    case_product: "Goods",
    case_service: "Services",
    subject: "Subject",
    description: "Description",
    currency: "Currency",
    contract_date: "Delivery Date",
    contract_amount: "Contract Amount",
    buyer: "Buyer",
    seller: "Seller",
    product: "Goods",
    payment: "Payment",
    courier: "Courier",
    actions: "",
    product_number: "#",
    product_title: "Title",
    product_sku: "HS commodity code",
    ai_search: "AI Search",
    run: "Run",
    product_qty: "Quantity",
    product_units: "Measure Units",
    product_unit_price: "Price",
    conditions: "Delivery Terms",
    conditions_code: "Delivery Terms Code",
    payment_conditions: "Payment Terms",
    payment_conditions_code: "Payment Terms Code",
    place: "Destination",
    term: "Delivery Date",
    is_public: "Public Contract",
    send_to_adb: "Send to ADB the whole documents folder",
    submit_button: "Save Contract",
    submit_and_sign_button: "Save and Sign",
    add_form: "Create New Contract",
    edit_form: "Edit Contract",
    current_contracts: "Contracts",
    products: "Goods",
    add_product: "Add Goods",
    add_place: "Add place",
    number_of_items: "Quantity",
    find_partner: "Partner search",
    find_param_1: "Parameter 1",
    find_param_2: "Parameter 2",
    find_param_3: "Parameter 3",
    find_param_4: "Parameter 4",
    find_param_5: "Parameter 5",
    find_param_6: "Parameter 6",
    search_other: "Search Outside ATTIS",
    shipping_cost: "Delivery Cost",
    search: "Search",
    search_china: "Search China company",
    save_search: "Save Search",
    send_notifications: "Send Notifications",
    saved_searches: "Saved Searches",
    search_results: "Search Results",
    contragents_search_id: "Candidate No",
    contragents_search_country: "Country",
    contragents_search_name: "Name",
    contragents_search_contact: "Company Title",
    contragents_search_sphere: "Business activity type",
    contragents_search_checked: "Selected",
    attis_contract_deadline: "Contract deadline",
    saved_searches_date: "Search date",
    saved_searches_number_of_results: "Number of results",
    documents_tab: "Documents",
    docs_cat_commerce: "Commerce",
    docs_cat_finance: "Finance",
    docs_cat_transport: "Transport",
    docs_cat_customs: "Customs",
    double_click_to_open: "Double click to download",
    add_file: "Add document",
    browse: "Drag and drop files or click to browse...",
    file_too_big: "Your file is more than 10Mb size. Please try another file.",
    file_wrong_type:
      "We support only JPG, PNG, PDF, DOC, XLS, DOCX and XLSX files. Please select correct file and try again.",
    offer: "Offer",
    products_description: "Product description",
    offer_status: "Status",
    offer_file: "File",
    offer_valid_date: "Offer validity date",
    offer_changes: "Changes",
    single_offer: "View offer",
    offer_answer: "Answer",
    offer_accept: "Accept",
    offer_decline: "Decline",
    contract_sign: "Sign the Contract",
    update_fields_you_need: "Update fields you need",
    offer_answer_title: "Answer to offer",
    offer_show_chain_answer: "Show chain",
    offer_answer_text: "Answer",
    offer_answer_send: "Send",
    single_document: "View Document",
    new_document: "Create Document",
    document_number: "Document Number",
    document_date: "Document Date",
    document_types: "Document Types",
    document_invoice: "Invoice",
    document_awb: "AWB",
    document_sad: "GTD",
    document_ktg_attorney: "KTZ power of attorney",
    document_ktg_attorney_no_logo: "KTZ power of attorney (No logo)",
    document_cmr: "CMR",
    document_save: "Save",
    document_save_validate: "Save and validate",
    document_create: "Create",
    document_create_validate: "Create and validate",
    document_file: "Document File  (up to 20Mb)",
    invoice_document_number: "Invoice Number",
    invoice_document_date: "Invoice Date",
    invoice_document_currency: "Invoice Currency",
    invoice_document_places_quantity: "Number of 'Cargo Places'",
    invoice_document_places_description: "Cargo Place Type",
    invoice_document_gross_weight: "Weight Brutto (kg)",
    invoice_document_net_weight: "Weight Netto (kg)",
    invoice_document_gcost: "Total Amount",
    invoice_document_discount: "Discount Amount",
    invoice_document_transport_charges: "Transportation Fees",
    invoice_document_insurance_charges: "Insurance Fees",
    invoice_document_other_charges: "Other Fees",
    invoice_document_total_cost: "Invoice Total Amount",
    invoice_document_payment_period: "Payment Date",
    invoice_document_buyer: "Buyer",
    invoice_document_seller: "Seller",
    invoice_products: "Invoice Commodities info",
    invoice_products_GoodMarking: "Producer Code",
    invoice_products_GoodsCode: "HS commodity code",
    invoice_products_GoodsDescription: "Commodity Description",
    invoice_products_GoodsQuantity: "Commodity Quantity",
    invoice_products_SupplementaryQualifierName: "Suppl. Unit of Measure",
    invoice_products_GrossWeightQuantity: "Commodity Weight, Brutto (kg)",
    invoice_products_NetWeightQuantity: "Commodity Weight, Netto (kg)",
    invoice_products_Price: "Commodity/Service Price",
    invoice_products_Discount: "Discount Amount",
    invoice_products_DiscountPercentage: "Discount %",
    invoice_products_OriginCountryCode: "Origin Country Code",
    invoice_products_ServiceCharges: "Service Fees",
    invoice_products_TransportCharges: "Transportation Fees",
    invoice_products_OtherCharges: "Other Fees",
    document_cancel_message: "Are you sure you want to cancel updates?",
    country: "Country",
    city: "City",
    cmr_products: "Commodities info",
    cmr_places: "CMR places",
    company_number: "ID",
    company_name: "Title",
    company_address: "Address",
    company_bank: "Bank",
    company_account: "Bank Account",
    company_phone: "Phone Number",
    company_email: "E-mail",
    company_fax: "Fax",
    add_seller: "Add Seller",
    add_buyer: "Add Buyer",
    offer_new: "Add Offer",
    cmr_products_GoodsMarking: "Marking and Numbers",
    cmr_products_GoodsQuantity: "Number of Places",
    cmr_products_GoodsDescription: "Cargo Title",
    cmr_products_GoodsNomenclatureCode: "HS commodity code",
    cmr_products_GrossWeightQuantity: "Commodity Weight, Brutto (kg)",
    cmr_products_VolumeQuantity: "Commodity (Cargo) Volume in cubic meter",
    cmr_places_typecode: "Type of package",
    cmr_places_count: "Number of cargo places",
    cmr_placesform_type_code: "Package / Cargo place type code",
    cmr_placesform_places_count: "Number of Cargo places / packages",
    cmr_placesform_places_description:
      "Description of Cargo places / packaging",
    cmr_placesform_part_count:
      "Number of packages / Cargo places partly occupied by the goods",
    cmr_track_reg_country_name: "Vehicle Registration Country",
    cmr_number: "CMR Number",
    cmr_date: "CMR Date",
    cmr_sender: "Sender",
    cmr_recipient: "Addressee",
    cmr_courier: "Carrier",
    cmr_courier_next: "Further Carrier",
    cmr_track: "Vehicle Model and Numberplate",
    cmr_trailer: "Trailer Numberplate",
    DeliveryPlace: "Destination",
    DeliveryTermsStringCode: "Delivery Terms",
    DeliveryTermsStringCode_code: "Delivery Terms Code",
    TermsDescription: "Comments",
    cmr_g_3: "Unloading Destination",
    cmr_g_4: "Loading Date and Location",
    cmr_CountryCode: "Country",
    cmr_City: "City",
    cmr_GoodsCost: "Declared Product Price",
    cmr_StreetHouse: "Address",
    cmr_PostalCode: "ZIP Code",
    cmr_TakingCargoDate: "Date of Loading",
    cmr_WarehouseName: "Bond or Customs Warehouse",
    add_courier: "Add Carrier",
    add_courier_next: "Add Further Carrier",
    add_sender: "Add Sender",
    add_recipient: "Add Addressee",
    sphere: "Business Activity",
    contr_search_name: "Title",
    contract_check_contragent: "Inspect Buyer/Seller?",
    good_selector: "Goods or service",
    close_document: "Close document",

    document_packaging: "Packing Lists",

    documents_packaging_number: "#",
    documents_packaging_invoice: "Invoice",
    documents_packaging_products_count: "Number of Commodities",
    documents_packging_list_for_invoice: "Invoice Packing List",
    documents_packaging_list_invoce_by_contract: "Invoice for Contract No",
    packaging_brutto_total: "Weight Brutto, Total",
    packaging_netto_total: "Weight Netto, Total",

    packaging_consignor: "Receiver",
    packaging_consignee: "Sender",

    packaging_number_pp: "#",
    packaging_goodsdescription: "Description",
    packaging_goodsquantity: "Quantity",
    packaging_placegoodsquantity: "Number of Places",
    packaging_places_tab: "Overall Number of Places",
    packaging_transport_tab: "Vehicle",
    packaging_product_tab: "Commodities",
    packaging_products_modal: "Commodities in Packing List",

    packaging_list_places_modal: "Overall Number of Places by Type",

    packaging_measureunitqualifiername: "Measure Unit",
    packaging_brutto: "Commodity Weight Brutto",
    packaging_netto: "Commodity Weight Netto",
    packaging_dimensions: "Commodity Dimentions",
    packaging_goodsvolume: "Commodity Volume",
    packaging_volumeunitqualifiername: "Volume Measure Unit",
    packaging_goodmarking: "Producer Code",

    packging_placescount: "Number of Places",
    packaging_placesdescription: "Places Description",
    packaging_packagingtypecode: "Packing Type Code",
    packaging_partialplacescount: "Number of Partially Loaded Places",

    packaging_list_transport_tab: "Vehicle",
    packaging_transport_number: "Vehicle No",
    packaging_transporttypecode: "Vehicle Type Code",
    packaging_transportcountrycode: "Vehicle Country of Reg",
    packaging_transportleading: "Lead Vehicle",

    packaging_prouct_packaging_modal_title: "Commodity Places",
    contract_group_new: "New",
    contract_group_mine: "My Contracts",
    contract_group_participate: "I Participate",

    conditions_tab: "Terms of the contract",
    attis_contract_conditions_overdue: "Percentage of late payment interest",
    attis_contract_conditions_packaging_transport_fees_included:
      "The cost of packaging and other expenses is included",
    attis_contract_conditions_goods_origin_country:
      "Country of origin of goods",
    attis_contract_conditions_point_of_departure: "Point of departure",
    attis_contract_conditions_destination_point: "Destination",
    attis_contract_conditions_days_to_change_price: "Price change, days",
    attis_contract_conditions_days_to_change_price_description:
      "The Seller [Supplier] has the right to change the prices of the Goods, provided that the Buyer is notified of the upcoming change at least __ days before such a change ",
    attis_contract_conditions_prepayment_percent: "% prepayment ",
    attis_contract_conditions_number_of_days_for_prepayment:
      "Prepayment period, days",
    attis_contract_conditions_number_of_days_for_fullpayment:
      "Full payment term, days",
    attis_contract_conditions_overdue_term: "Delay period",
    attis_contract_conditions_shipping_term: "Shipment time, days",
    attis_contract_conditions_total_delivery_time: "General delivery time",
    attis_contract_conditions_days_to_receive_goods: "Acceptance period, days",
    attis_contract_conditions_days_to_quality_receive_goods:
      "Acceptance for quality, days",
    attis_contract_conditions_transfer_of_ownership: "Transfer of ownership",
    attis_contract_conditions_guarantee_term: "Guarantee period",
    attis_contract_conditions_exceeding_guaranty_term:
      "Exceeding the warranty period",
    attis_contract_conditions_payment_overdue: "Delay in payment, interest%",
    attis_contract_conditions_shipping_overdue:
      "Penalty for late delivery, % per day",
    attis_contract_conditions_payment_overdue_description:
      "_% of the overdue amount for each day of delay in payment",
    attis_contract_conditions_shipping_overdue_description:
      "% of the value of the unshipped consignment of Goods for each day of delay",
    attis_contract_conditions_decline_due_to_overdue:
      "Cancellation due to delay in delivery, days",
    attis_contract_conditions_legal_country: "Country of law",
    attis_contract_conditions_arbitrage_country: "Country of arbitration",
    attis_contract_conditions_contract_language: "Contract languages",
    attis_contract_conditions_contract_term: "Duration of the contract, date",
    attis_contract_conditions_notification_term: "Notice period",
    attis_contract_conditions_product_and_delivery: "Product and delivery",
    attis_contract_conditions_quality_doc:
      "Document confirming the quality of the goods",
    attis_contract_conditions_not_accept_fine:
      "Penalty for unreasonable refusal to accept the goods, % of the total cost",
    attis_contract_conditions_opening_letter_deadline:
      "Deadline for opening a letter of credit",
    attis_contract_conditions_opening_letter_deadline_description:
      ", not later than, days (letter of credit)",
    attis_contract_conditions_letter_payment_documents:
      "Documents of payment under a letter of credit",
    attis_contract_conditions_letter_payment_documents_description:
      "the list of documents submitted to the bank for payment",
    attis_contract_conditions_docs_deadline_after_letter:
      "The deadline for submitting documents to the bank",
    attis_contract_conditions_docs_deadline_after_letter_description:
      "when paying by letter of credit from the moment it is opened",
    attis_contract_conditions_default_lang:
      "The prevailing language of the contract in case of discrepancies",
    attis_contract_conditions_payment: "Payment",
    attis_contract_conditions_contract_details: "Contract Details",
    attis_contract_conditions_place_of_detention: "Place of detention",
    attis_contract_conditions_buyer_basis: "The buyer acts on the basis",
    attis_contract_conditions_seller_basis: "The seller acts on the basis",
    attis_contract_conditions_buyer_full_name: "Buyer full name",
    attis_contract_conditions_seller_full_name: "Seller full name",
    russian: "Russian",
    english: "English",
    chinese: "Chinese",
    russian_english: "Russian - English",
    russian_chinese: "Russian - Chinese",
    english_chinese: "English - Chinese",
    select_ecp_type: "Choose a signature method",
    only_for_kz:
      "For residents of the Republic of Kazakhstan. NCALayer required",
    sign_with_ecp: "Sign EDS",
    sign_with_code: "Sign with code",
    input_signature_code: "Enter the code sent to your E-mail",
    signed_message_signature: "EDS signed",
    signed_message_code: "Code signed",
    check_seller: "Check seller",
    check_buyer: "Check buyer",
    contract_check_contragent_alert:
      "Attention! Buyer / Seller verification is a paid service.",
    history_action_type: "Action type",
    history_action_created_by: "Action created by",
    history_action_date: "Action date",
    history_tab: "Contract history",
    history_contract_owner_sign: "Contract sign by owner",
    history_new_contract: "New contract",
    history_contract_update: "Contract update",
    history_contract_delete: "Contract delete",
    history_accept_contract: "Accept contract",
    history_contract_contragent_sign: "Contract signed by counterparty",
    history_new_ktg: "New ktg",
    history_delete_broker_contract: "Broker contract delete",
    history_new_broker_contract: "New broker contract",
    history_update_broker_contract: "Broker contract update",
    history_sftp_download: "SFTP file download",
    history_delete_document: "Delete document",
    history_new_invoice: "New invoice",

    history_new_RWB: "New railway bill",
    history_update_RWB: "Update railway bill",
    history_delete_RWB: "Delete railway bill",
    history_new_insurance: "New insurance",
    history_update_insurance: "Update insurance",
    history_delete_insurance: "Delete insurance",
    history_new_liability_insurance: "New liability insurance",
    history_update_liability_insurance: "Update liability insurance",
    history_delete_liability_insurance: "Delete liability insurance",

    history_new_invoice_goods: "New invoice goods",
    history_invoice_update: "Invoice update",
    history_new_cmr: "New CMR",
    history_new_cmr_cargo: "New CMR cargo",
    history_new_cmr_goods: "New CMR goods",
    history_cmr_update: "CMR update",
    history_new_fm1: "New fm1",
    history_fm1_update: "fm1 update",
    history_new_epi: "New epi",
    history_epi_update: "epi update",
    history_new_awb: "New awb",
    history_awb_update: "Awb update",
    history_new_packing_list: "New packing list",
    history_packing_list_update: "Packing list update",
    history_delete_packing_list: "Delete packing list",
    history_new_places: "New places",
    history_places_update: "Places update",
    history_delete_places: "Delete places",
    view_form: "View deal",
    select_radio_button: "Select",

    history_new_broker_offer: "New broker offer",
    history_select_broker_offer: "Select broker offer",
    history_decline_broker_offer: "Decline broker offer",
    history_accept_broker_offer: "Accept broker offer",
    history_broker_offer: "Broker offer",
    history_select_courier_offer: "Select courier offer",
    history_decline_courier_offer: "Decline courier offer",
    history_courier_offer: "Courier offer",
    history_new_courier_offer: "New courier offer",
    history_delete_offer: "Delete offer",
    history_sign_offer: "Sign offer",
    history_new_offer: "New offer",
    history_decline_offer: "Decline offer",
    history_accept_offer: "Accept offer",
    history_answer_offer: "Answer offer",
    history_contract_update: "Contract update",
    history_contract_delete: "Contract delete",
    history_accept_contract: "Accept contract",
    history_new_ktg: "New ktg",
    history_delete_document: "Delete document",
    history_new_invoice: "New invoice",
    history_new_invoice_goods: "New invoice goods",
    history_invoice_update: "Invoice update",
    history_new_cmr: "New CMR",
    history_new_cmr_cargo: "New CMR cargo",
    history_new_cmr_goods: "New CMR goods",
    history_cmr_update: "CMR update",
    history_new_fm1: "New fm1",
    history_fm1_update: "fm1 update",
    history_new_epi: "New epi",
    history_epi_update: "epi update",
    history_new_awb: "New awb",
    history_awb_update: "Awb update",
    history_new_packing_list: "New packing list",
    history_packing_list_update: "Packing list update",
    history_delete_packing_list: "Delete packing list",
    history_new_places: "New places",
    history_places_update: "Places update",
    history_delete_places: "Delete places",
    paper_copy_packing: "Packing lists",
    paper_copy_packing_no_logo: "Packing lists (No logo)",
    docs_cat_all: "All",

    document_rwb: "Railway bill",
    rwb_doc_id: "Document ID",
    rwb_refdocid: "Document number",
    rwb_consignor_notice: "Shipper Notice",
    rwb_places_quantity: "Number of places",
    rwb_gross_weight_quantity: "Gross weight",
    rwb_departure_mode_description: "Send type description",
    rwb_loader_mode_description: "Description of the type of loading",
    rwb_additional_sheet_quantity: "Number of additional sheets",
    rwb_cargo_value: "Cargo cost",
    rwb_customs_notice: "Customs notification",
    rwb_weight_definition_mode_description:
      "Description of the type of weight determination",
    rwb_carrier_notice: "Carrier Notice",
    rwb_commerce_akt: "Commercial act",
    rwb_prolongation: "Prolongation",
    rwb_issue_marks: "Issue flagging",
    rwb_amount60: "Amount 60",
    rwb_amount61: "Amount 61",
    rwb_amount62: "Amount 62",
    rwb_amount63: "Amount 63",
    rwb_calculation_notice: "Settlement Notice",
    rwb_addition_payment: "Additional payment",

    rwb_consignor_option_notice: "Shipper's Note",
    rwb_consignor: "Consignor",
    rwb_consignee: "Consignee",
    rwb_departure_station_code: "Departure station code",
    rwb_departure_station_name: "Departure station name",
    rwb_departure_rwcode: "Railway code of departure point",
    rwb_departure_rwname: "Railway name of departure point",
    rwb_departure_country: "Departure country",
    rwb_destination_rwcode: "Destination railway code",
    rwb_destination_station_code: "Destination station code",
    rwb_destination_rwand_station_name: "Destination station name",
    rwb_border_station_code: "Border station code",
    rwb_border_station_name: "Name of the border station",
    rwb_border_rwcode: "Border station railway code",
    rwb_border_rwname: "The name of the border station railway",
    rwb_border_country: "border country",
    rwb_contract_name: "Name of the contract",
    rwb_contract_number: "Contract number",
    rwb_contract_date: "Contract date",
    rwb_flat_pallet_quantity: "Number of flat pallets",
    rwb_box_pallet_quantity: "Number of box pallets",
    rwb_pallet_exchange_mode: "Pallet exchange method",
    rwb_work_tool_id: "Tool ID",
    rwb_work_tool_container_description:
      "Description of the working tool container",
    rwb_work_tool_railway_code: "Working tool code",
    rwb_mark_sing: "mark sign",
    rwb_mark_kind: "mark type",
    rwb_mark_result_control: "Mark result control",
    rwb_contract_carrier_name: "Contract carrier name",
    rwb_contract_carrier_time: "Time at the carrier under the contract",
    rwb_contract_carrier_date: "Date at the carrier under the contract",
    rwb_contract_carrier_date_time_moscow:
      "Date and time at the carrier under the contract (MSK)",
    rwb_contract_carrier_date_time_moscow_date:
      "Date at the carrier under the contract (MSK)",
    rwb_contract_carrier_date_time_moscow_time:
      "Time at the carrier under the contract (MSK)",
    rwb_contract_carrier_station_code: "Contract carrier station code",
    rwb_contract_carrier_station_name: "Contract carrier station name",
    rwb_contract_carrier_rw_name:
      "Name of the railway carrier under the contract",
    rwb_contract_carrier_country: "Contract carrier country",
    rwb_arrival_carrier_name: "Arrival carrier name",
    rwb_arrival_date: "Arrival date",
    rwb_arrival_time: "Arrival time",
    rwb_arrival_date_time_moscow: "Date and time of arrival (MSK)",
    rwb_arrival_date_time_moscow_date: "Date of arrival (MSK)",
    rwb_arrival_date_time_moscow_time: "Arrival time (MSK)",
    rwb_arrival_station_code: "Arrival station code",
    rwb_arrival_station_name: "Arrival station name",
    rwb_arrival_rw_name: "Arrival railway name",
    rwb_arrival_rw_code: "Arrival railway code",
    rwb_arrival_country: "Destination country",
    rwb_good_container_indicator: "Container",
    rwb_good_work_tool_description: "Work tool",
    rwb_good_conductor_description: "Conductor Description",
    rwb_good_place_goods_quantity: "Quantity",
    rwb_good_places_quantity: "Number of seats",
    rwb_good_gross_weight_quantity: "Gross weight",
    rwb_good_places_description: "Description of places",
    rwb_good_harmonized_range_goods: "Harmonized product range",
    rwb_good_packing: "Package",
    rwb_good_marking: "TNVED",
    rwb_good_carriage_number: "Wagon number",
    rwb_good_container_number: "Container number",
    rwb_good_goods_numeric: "Goods numerical",
    rwb_good_customs_code: "customs code",
    rwb_good_gtd_number: "GTD number",
    rwb_good_gcost: "Price",
    rwb_good_currency: "Currency",
    rwb_good_mrn: "MRN",

    rwb_carrier_id: "ID",
    rwb_carrier_carrier_name: "Carrier name",
    rwb_carrier_carrier_code: "Carrier code",
    rwb_carrier_from_station_code: "Departure point code",
    rwb_carrier_from_station_name: "Departure point name",
    rwb_carrier_from_rw_name: "Railway name of departure point",
    rwb_carrier_from_country: "Departure country",
    rwb_carrier_to_station_code: "Destination code",
    rwb_carrier_to_station_name: "Destination name",
    rwb_carrier_to_rw_name: "Railway name Destination",
    rwb_carrier_to_country: "Destination country",
    rwb_carrier_tech_station: "Technical station",

    rwb_carrier_tech_station_order_number: "Order number",
    rwb_carrier_tech_station_tech_signs: "Those. signs",
    rwb_carrier_tech_station_station_code: "Station code",
    rwb_carrier_tech_station_station_name: "Station name",
    rwb_carrier_tech_station_rw_name: "Railway name",
    rwb_carrier_tech_station_country: "CountryCountry",

    rwb_container_container_id: "Container ID",
    rwb_container_rw_code: "Railway code",
    rwb_container_container_kind: "Container type",
    rwb_container_container_mode_desc: "Mode description",
    rwb_container_container_capacity: "Capacity",
    rwb_container_container_capacity_unit_code: "unit of measurement",
    rwb_container_tare: "Container",
    rwb_container_goods_weight: "Goods weight",
    rwb_container_places_quentity: "Number of goods",
    rwb_container_pocket_quentity: "Number of pockets",
    rwb_container_container_length: "Container length",

    rwb_auto_vin: "VIN",
    rwb_auto_transport_kind: "Vehicle type",
    rwb_auto_transport_mark: "Vehicle brand",
    rwb_auto_transport_identifier: "Vehicle ID",
    rwb_auto_transport_nationality: "Vehicle country",
    rwb_auto_active_transport_identifier: "Active vehicle ID",
    rwb_auto_transport_regnumber: "Registration number",
    rwb_auto_wagon_number: "Wagon number",
    rwb_auto_tare: "Container",
    rwb_auto_goods_weight: "Goods weight",
    rwb_auto_places_quentity: "Number of goods",
    rwb_auto_pocket_quentity: "Number of pockets",
    rwb_auto_container_length: "Container length",

    rwb_carriage_carriage_id: "wagon ID",
    rwb_carriage_rw_name: "Railway name",
    rwb_carriage_owner_name: "Wagon owner",
    rwb_carriage_owner_type: "Owner Type",
    rwb_carriage_rw_power: "Railway power",
    rwb_carriage_axis_quentity: "Number of axles",
    rwb_carriage_tare: "Container",
    rwb_carriage_goods_weight: "Goods weight",
    rwb_carriage_caliber: "Caliber",

    rwb_seal_seal_id: "ID",
    rwb_seal_seal_quentity: "Quantity",
    rwb_seal_ident_kind: "View",
    rwb_seal_ident_desc: "Description",

    rwb_stamp_carrier_name: "Carrier name",
    rwb_stamp_date: "Date",
    rwb_stamp_time: "Time",
    rwb_stamp_date_time_moscow: "Date and time (MSK)",
    rwb_stamp_date_time_moscow_date: "Date (MSK)",
    rwb_stamp_date_time_moscow_time: "Time (MSK)",
    rwb_stamp_station_code: "Station code",
    rwb_stamp_station_name: "Station name",
    rwb_stamp_rw_name: "Railway name",
    rwb_stamp_rw_code: "Railway code",
    rwb_stamp_country: "The country",

    rwb_carrier_charge_order_no: "Order no.",
    rwb_carrier_charge_carrier_code: "Carrier code",
    rwb_carrier_charge_from_station_code:
      "Departure station codeод станции отправления",
    rwb_carrier_charge_from_station_name: "Departure station name",
    rwb_carrier_charge_from_rw_name: "Name of railway departure",
    rwb_carrier_charge_from_country: "Departure country",
    rwb_carrier_charge_to_station_code: "Destination station code",
    rwb_carrier_charge_to_station_name: "Destination station name",
    rwb_carrier_charge_to_rw_name: "Destination railway name",
    rwb_carrier_charge_to_country: "Destination country",
    rwb_carrier_charge_distance: "Distance",
    rwb_carrier_charge_calc_weight: "Estimated weight",
    rwb_carrier_charge_extra_charge_code: "Additional fee code",
    rwb_carrier_charge_extra_charge_name: "Name of additional board",
    rwb_carrier_charge_extra_charge_amount: "Amount of additional fee",
    rwb_carrier_charge_tarif_code: "Fare code",
    rwb_carrier_charge_calc_cargo_code: "Cargo calculation code",
    rwb_carrier_charge_currency_rate: "Rate",
    rwb_carrier_charge_snd_tarif_currency_code: "SND tariff currency",
    rwb_carrier_charge_snd_payment_currency: "Currency of payment for SND",
    rwb_carrier_charge_rcv_tarif_currency_code: "RCV fare currency",
    rwb_carrier_charge_rcv_payment_currency: "Payment currency",
    rwb_carrier_charge_amount48: "Amount 48",
    rwb_carrier_charge_amount49: "Amount 49",
    rwb_carrier_charge_amount50: "Amount 50",
    rwb_carrier_charge_amount51: "Amount 51",
    rwb_carrier_charge_amount52: "Amount 52",
    rwb_carrier_charge_amount53: "Amount 53",
    rwb_carrier_charge_amount54: "Amount 54",
    rwb_carrier_charge_amount55: "Amount 55",
    rwb_carrier_charge_amount56: "Amount 56",
    rwb_carrier_charge_amount57: "Amount 57",
    rwb_carrier_charge_amount58: "Amount 58",
    rwb_carrier_charge_amount59: "Amount 59",

    rwb_paid_rw_code_paid_rw_name: "Railway name",
    rwb_paid_rw_code_paid_rw_code: "Railway code",
    rwb_paid_rw_code_paid_rw_short: "Short name",
    rwb_paid_rw_code_payer_code: "Payer code",
    rwb_paid_rw_code_payer_name: "Payer's name",
    rwb_paid_rw_code_from_rw_name: "Railway departure",
    rwb_paid_rw_code_from_country: "Departure country",

    rwb_consignor_doc_doc_name: "Document's name",
    rwb_consignor_doc_doc_number: "Document Number",
    rwb_consignor_doc_doc_date: "Document date",
    rwb_consignor_doc_mode_code: "View Code",
    rwb_consignor_doc_expiration_date: "Action end date",
    rwb_consignor_doc_release_customs: "Customs clearance",

    rwb_tab_data: "Data",
    rwb_tab_goods: "Goods",
    rwb_tab_carrier: "Carriers",
    rwb_tab_carrier_charge: "Carrier fees",
    rwb_tab_transport: "Transport",
    rwb_tab_container: "Containers",
    rwb_tab_auto: "Auto",
    rwb_tab_carriage: "Wagons",
    rwb_tab_seal_stamp: "Seals",
    rwb_tab_seal: "Seals",
    rwb_tab_stamps: "Seals",
    rwb_tab_paid_rw_code: "Railway payments",
    rwb_tab_consignor_doc: "Documents",

    custom_code: "Full details of custom post",
    courier_notes: "Carrier's clauses and notes",
    cmr_docs: "List of attached documents",
    cmr_doc_type: "Document type",
    cmr_doc_number: "Document Number",
    cmr_doc_date: "Date",
    save_place: "Update place",

    broker_contract: "Broker contract",
    broker_contract: "Broker contract (No logo)",
    bc_number: "Number",
    bc_city: "City",
    bc_date: "Date",
    bc_agreement: "Agreement",
    bc_penalty_amount: "Penalty amount",
    bc_currency: "Currency",
    bc_trial_city: "Trial city",
    bc_trial_language: "Trial language",
    broker_select_radio_btn: "Select",
    contract_history_data: "History data",

    transport_contract: "Contract of carriage",
    cancel_term: "Cancellation of the Application (hours)",
    consent_term: "Carrier consent (hours)",
    inform_term: "Informing the client (hours)",
    location_term: "Location (hours)",
    fuel_percent: "Increase in the cost of diesel fuel (%)",
    currency_percent: "Rise in the exchange rate (%)",
    application_term: "Apply (hours)",
    customs_term: "Customs clearance (hours)",
    payment_term: "Make payment (days)",
    delay_abroad_term: "Downtime for international transportation (days)",
    delay_home_term: "Domestic downtime (days)",
    courier_cis_delay_amount: "Late submission of a car in the CIS (tenge)",
    customer_cis_delay_amount: "Downtime in the CIS (tenge)",
    courier_eu_delay_amount: "Late submission of a car to the EU (tenge)",
    customer_eu_delay_amount: "Downtime in the EU (tenge)",
    courier_declination_percent: "Penalty upon refusal of the Contractor (%)",
    penalty_percent: "Late Payment Penalty (%)",
    penalty_never_more: "Penalty no more than (%)",
    customer_declination_percent: "Penalty upon refusal of the Client (%)",
    act_term: "The act is considered signed in (days)",
    repeats_term: "Force majeure duration (days)",
    force_major_term: "Form Major Notification Period (days)",
    claim_term: "Claim consideration period (days)",
    resolve_term: "Dispute Resolution Institute",
    contract_term: "Contract time",
    contract_cancel_term: "Termination notice period (days)",

    insurance_policy_holder_name: `Name of the Policyholder:`,
    insurance_represented_by: `represented by (full name, position):`,
    insurance_legal_address: `Legal address:`,
    insurance_actual_address: `The actual address:`,
    insurance_is_public_person: `Are you a foreign public person (to be completed, individual or individual entrepreneur)?`,
    insurance_insured_details: `Details of the Insured:`,
    insurance_insured_activity: `Type of activity of the Insured:`,
    insurance_beneficiary: `Beneficiary:`,
    insurance_beneficiary_details: `Details of the Beneficiary:`,
    insurance_shipping_name: `Shipping Name:`,
    insurance_package_info: `Information about the type of packaging and special protective coatings:`,
    insurance_cargo_cost: `The cost of cargo in one package and (or) in one special cover:`,
    insurance_package_count: `Number of packages and (or) objects in special protective coatings:`,
    insurance_total_cost: `The total cost of the consignment:`,
    insurance_release_date: `Date of issue (production) of the cargo:`,
    insurance_containerization: `Containerization: Complete?`,
    insurance_cargo_placing: `Describe the method (method) of cargo placement and the number of containers:`,
    insurance_route: `Route:`,
    insurance_security_measures: `Security measures taken:`,
    insurance_transport_means: `Transportation of goods is carried out through:`,
    insurance_transfer_points: `Transfer points where it is planned to change the type of vehicle:`,
    insurance_shipping_details: `Details of shipping documents:`,
    insurance_risk: `Insured risks:`,
    insurance_risk_a: `Condition A "With responsibility for all risks"`,
    insurance_risk_b1: `Condition B "With liability for a partial accident"`,
    insurance_risk_b2: `Condition B "No liability for damages"`,
    insurance_additional_conditions: `Additional terms:`,
    insurance_max_value: `Maximum insured value of cargo:`,
    insurance_max_value_a: `A) in one container`,
    insurance_max_value_b: `B) in one vehicle`,
    insurance_max_value_c: `C) on the same ship`,
    insurance_max_value_d: `D) on one aircraft`,
    insurance_max_value_e: `E) on one railway car`,
    insurance_max_value_f: `F) in one place of storage`,
    insurance_insured_transport: `The sum insured includes transport and insurance costs.`,
    insurance_insured_transport_amount: `Sum insured (for consignment):`,
    insurance_franchise: `Franchise:`,
    insurance_shipment_date: `Shipment date:`,
    insurance_shipment_duration: `Time spent on the way`,
    insurance_insurance_stats: `Statistical data:`,
    insurance_insurance_stats_desc: `Provide statistical data on any insured events that have occurred with your cargo over the past three years (cargo value, losses incurred, etc.)`,
    insurance_relevant_info: `Please provide any information that you think is relevant to this risk:`,
    insurance_other: `Other:`,
    document_insurance: "Cargo insurance",

    document_liability_insurance: "Civil Liability Insurance",
    liability_insurance_policy_holder: "Policyholder",
    liability_insurance_policy_holder_name: "Name",
    liability_insurance_policy_holder_address: "Location",
    liability_insurance_policy_holder_phone: "Phone number",
    liability_insurance_policy_holder_email: "E-mail",
    liability_insurance_policy_holder_bank: "Bank details",
    liability_insurance_policy_holder_bin: " BIN",
    liability_insurance_policy_holder_bik: "BIC",
    liability_insurance_is_resident: "Sign of residency",
    liability_insurance_license_no: "license number",
    liability_insurance_economy_sector: "Sector of the economy",
    liability_insurance_activity_type: "Type of economic activity",
    liability_insurance_object_teritory: "Territorial feature of the object",
    liability_insurance_insured_details: "insured",
    liability_insurance_insured_sum: "Sum insured for risks causing harm",
    liability_insurance_life_insured_sum: "Life and health of third parties",
    liability_insurance_property_insured_sum: "Property of third parties",
    liability_insurance_cargo_insured_sum: "To the owner of the cargo",
    liability_insurance_insured_limit: "Liability limit",
    liability_insurance_total_insured_sum:
      "Cumulative limit of liability for all risks",
    liability_insurance_insurance_term: "Term of insurance",
    liability_insurance_insurance_teritory: "Territory of insurance",
    liability_insurance_transport_type: "Kind of transport",
    liability_insurance_transport_h:
      "Freight forwarding is carried out using all modes of transport",
    liability_insurance_transport_model: "model",
    liability_insurance_transport_name: "title",
    liability_insurance_transport_reg_number: "registration number",
    liability_insurance_transport_body_number: "body number",
    liability_insurance_transport_release_date: "year of issue",
    liability_insurance_vehicles_number: "Number of vehicles",
    liability_insurance_previous_insurance_info:
      "Information about the previous liability insurance contract",
    liability_insurance_valid_contracts_info:
      "Information on valid contracts of voluntary insurance of civil liability",
    liability_insurance_insurer:
      "INFORMATION ABOUT THE REPRESENTATIVE OF THE INSURER",
    liability_insurance_insurer_name:
      "Full name, position, name of the legal entity (agent)",
    liability_insurance_insurer_address: "Address, location",
    liability_insurance_insurer_phone: "Phone (work and cell)",
    liability_insurance_insurer_commission: "Insurance agent commission ",
    liability_insurance_insurer_contact_name:
      "Full name, position, name of the insurer contact person",
    liability_insurance_insurer_contact_address:
      "Insurer contact person address, location",
    liability_insurance_insurer_contact_phone:
      "Insurer contact person phone (work and cell)",
    liability_insurance_insurance_date: "Date of application submission",
    liability_insurance_franchise: "Franchise",
    liability_insurance_payout_term: "Payout term",
    broker_select_radio_btn: "Select",
    upload_ktzh_answer: "Download answer KTZ",
    show_ktzh_request: "View Request",
    show_ktzh_answer: "View answer",

    send_insurance_request: "Send an application to the insurer",
    download_insurance_certificate: "Download insurance certificate",
    contract_history_data: "Historical data",
    pdf_aml: "Company verification",
    pdf_aml_no_logo: "Company verification (No logo)",

    document_epi: "EPI",

    document_epi_tab_1: "General information",
    document_epi_tab_1_short: "General",
    document_epi_tab_2: "Information about the consignment",
    document_epi_tab_2_short: "Goods consignment",
    document_epi_tab_3: "Sender Receiver",
    document_epi_tab_3_short: "Sender Receiver",
    document_epi_tab_4: "Information about the transportation of goods",
    document_epi_tab_4_short: "Shipping",
    document_epi_tab_5: "Commodity part Gr. 31-47",
    document_epi_tab_5_short: "Commodity part",
    document_epi_tab_6: "Previous Documents. Gr. 40.",
    document_epi_tab_6_short: "Documents",

    ap_main_reg_num: "Gr.A Registration number of preliminary information",
    ap_main_country_code: "Country code",
    ap_main_reg_date: "Date of registration",
    ap_main_trans_kind_code: "Target Code",
    ap_main_transit_direction_code: "Type of transportation",
    ap_main_electronic_document_sign: "Gr.1 Sign of ED",
    ap_main_declaration_kind: "Product declaration feature code",
    ap_main_subsoil_sign: "Sign of the subsoil user. for RK",
    ap_main_seal_number: "Sealer number in TD",
    ap_main_seal_quantity: "Number of applied seals in TD",
    ap_main_language_cuesad: "Document language code",
    ap_main_recipient_country_code:
      "Country code of the customs authority to which the document is submitted",
    ap_main_movement_code: "Purpose of moving to TD",
    ap_main_movement_code_code: "The code of the purpose of movement in the TD",
    ap_main_transit_direction_code_1: "IM",
    ap_main_transit_direction_code_2: "EC",
    ap_main_transit_direction_code_3: "TR",
    ap_main_transit_direction_code_4: "WT",
    ap_main_transit_direction_code_5: "TS",

    ap_goods_group: "Information about the consignment",
    ap_good_origin_country_name: "Country of origin of goods",
    ap_good_specification_number: "Total Specs",
    ap_good_specification_list_number: "Total number of specification sheets",
    ap_good_total_goods_number: "Gr.5 Total items of goods",
    ap_good_total_package_number: "Gr.6 Total number of packages",
    ap_good_total_sheet_number: "Number of sheets DT/TD",
    ap_good_total_cust_cost: "Gr.22 Total cost of goods",
    ap_good_cust_cost_currency_code: "Gr.22 Letter currency code",

    ap_sender_group: "Gr.2 Information about the sender of goods",
    ap_memb_organization_name: "Name",
    ap_memb_short_name: "Short title",
    ap_memb_bin: "BIN",
    ap_memb_itn: "ITN",
    ap_sender_org_address: "Organization address",
    ap_member_postal_code: "Postcode",
    ap_member_country_name: "Country code",
    ap_member_region: "Region (region, state, province, etc.)",
    ap_member_city: "Locality",
    ap_member_street_house: "Street, house number, office number",
    ap_recipient_group: "Gr.8 Information about the recipient of the goods",

    ap_recipient_address: "Organization address",

    ap_lico_fin_ureg_group: "Person responsible for financial settlement",

    ap_lico_fin_ureg_address: "Organization address",

    ap_declarant_group: "Information about the declarant of goods",

    ap_declarant_address: "Organization address",

    ap_person_declaraed_group:
      "Information about the person who filled out the declaration. Gr. 54/ gr 50 TD",
    ap_person_person_surname: "Surname",
    ap_person_person_name: "Name",
    ap_person_person_middle_name: "Middle name",
    ap_person_person_post: "Position",
    ap_person_contact_phone: "Phone number",
    ap_courier_group: "Information about the carrier 50 TD",

    ap_courier_address: "Organization address",

    ap_drivers_group: "Information about vehicle drivers",

    ap_person_reg_country_code:
      "Code of the country of registration of the driver of the vehicle",
    ap_document_id: "Identity document",
    ap_send_rec_identity_card_code: "Document type code",
    ap_send_rec_identity_card_series: "A series of documents",
    ap_send_rec_identity_card_number: "Document Number",
    ap_send_rec_identity_card_date: "Document issue date",
    ap_send_rec_organization_name:
      "Name of the organization that issued the document",

    ap_send_rec_identitry_card_code_1: "the passport",
    ap_send_rec_identitry_card_code_2: "driver's license",

    ap_transportations_place_group: "Location of goods. Gr. 30 DT",
    ap_transp_information_type_code: "Information type",
    ap_transp_customs_office: "customs Department",
    ap_transp_customs_office_code: "Code of the customs authority",
    ap_transp_customs_country_code: "Customs country code",
    ap_transportations_transport_group:
      "Information about the transportation of goods. Gr. 15, 15a, 17, 17a, 18, 19, 21, 25, 26, 29 - DT / Gr. 15, 17, 18, 19, 21, 25, 26, 29, 53, 55 - TD",
    ap_transp_container_indicator: "Gr.19 Sign of container transportation",
    ap_transp_dispatch_country_code: "Gr.15 Country of departure",
    ap_transp_destination_country_code: "Gr.17 Country of destination",
    ap_transportations_customs_group: "Gr.29 Customs office of entry/exit",
    ap_transp_customs_office_inout: "Code of the customs authority",
    ap_transp_customs_country_code_io:
      "State code of a member of the Customs Union",
    ap_transp_date_expected_arrival: "Date of expected arrival",
    ap_transportations_transport_facilities_group:
      "Gr.18.26 Vehicles upon arrival/departure",
    ap_transp_transport_mode_code: "Gr.25 Vehicle type code",
    ap_transp_transport_nationality_code:
      "Letter code of the country of ownership of vehicles",
    ap_transportations_transport_description_group: "Vehicle Description",
    ap_transp_vin: "Chassis number (VIN)",
    ap_transp_transport_identifier: "Vehicle number",
    ap_transp_active_transport_identifier: "Active vehicle ID",
    ap_transp_information_type_code_11: "11 - TSW",
    ap_transp_information_type_code_21: "21 - TS",
    ap_transp_information_type_code_25: "25 - Free warehouse",
    ap_transp_information_type_code_31: "31 - Consignee's warehouse",
    ap_transp_information_type_code_41:
      "41 - Warehouse for storing own goods (for the Republic of Kazakhstan)",
    ap_transp_information_type_code_52: "52 - Vehicle",
    ap_transp_information_type_code_60: "60 - Premises (sites) AEO",
    ap_transp_information_type_code_72: "72 - ZTK (for Belarus)",
    ap_transp_information_type_code_91:
      "91 - Storage location address (for Belarus)",
    ap_transp_information_type_code_99: "99 - Another place VX",
    ap_transp_information_type_code_80: "80 - SEZ.",
    ap_good_data_group: "Commodity part Gr. 31-47",
    ap_good_data_goods_numeric:
      "Serial number of the declared goods / number of the goods according to the list /",
    ap_good_data_list_numeric: "Item number in the list",
    ap_good_data_goods_description: "Name",
    ap_good_data_gross_weight_quantity: "Goods weight, gross (kg)",
    ap_good_data_net_weight_quantity: "Goods weight, net (kg)",
    ap_good_data_invoiced_cost: "Price / value of goods",
    ap_good_data_customs_cost: "Customs value of goods",
    ap_good_data_statistical_cost: "Statistical cost of goods",
    ap_good_data_goods_tnved_code: "Gr.33 Product code according to HS Code TS",
    ap_good_data_origin_country_code: "Country of origin code",
    ap_good_data_delivery_terms_string_code: "Delivery terms code",

    save_product: "Save",
    save_doc: "Save Document",
    add_doc: "Add Document",
    epi_to_xml: "Send to TO",

    ap_prev_doc_group: "Gr.40 Previous documents",
    ap_prev_doc_preceding_document_date: "Previous document - date",
    ap_prev_doc_preceding_document_number: "Document registration number",
    PrecedingDocumentName: "Name of the previous document",

    document_delete_message: "Are you sure you want to delete the document?",

    good_selector: "Product or service",
    good_selector_c1: "Chapter",
    good_selector_c2: "The Department",
    good_selector_c3: "Group",
    good_selector_c4: "Class",
    good_selector_c5: "Name",

    ap_main_decl_num: "Gr.A Internal TD number",
    ap_main_decl_date: "Gr.50 Date of issue of TD",
    ap_main_carnet: "Gr.1 Sign of transportation under the TIR Carnet",
    ap_transp_date_expected_arrival_time: "Expected arrival time",
    ap_good_data_quant: "Quantity of goods",
    ap_good_data_ext_measure: "Add. units measurements",
    ap_good_data_container_num: "Container numbers",
    ap_prev_doc_kind: "Document code",

    ap_good_data_places_group:
      "Information about the cargo, packages, pallets and packaging of goods",
    ap_good_data_places: "The total number of packages occupied by the goods",
    ap_good_data_packet: "Product packaging availability code",
    ap_good_data_places_name: "Name of the type of packages",

    ap_good_data_packet_0: "0 - Without packaging",
    ap_good_data_packet_1: "1 - With packaging",
    ap_good_data_packet_2:
      "2 - Without packaging in the equipped containers of the vehicle",

    offer_target_name: "The offer to",

    document_fm1: "AML",

    pdf_liability_insurance: "Liability insurance",
    pdf_liability_insurance_no_logo: "Liability insurance (No logo)",

    check_contragent_price_alert:
      "Attention! Buyer / Seller verification is a paid service. The price is ",
    kyc_service_message:
      "The Counterparty Verification Service provides information obtained from official resources and the media. The system enables the User to receive changes in information about the desired object in the mode of monitoring its status. The information is for reference only. The ATTIS platform is not responsible for the consequences of using the information received. The decision on further actions related to the search results is taken by the User. ",
    excel_import_gooods_label: "Import goods from Excel",

    ktg_attorney_principal: "Principal of attorney",
    ktg_attorney_principal_name: "Full name",
    ktg_attorney_principal_reg_number: "Registration number",
    ktg_attorney_principal_code: "BIN",
    ktg_attorney_principal_address: "Address",

    ktg_attorney_representative: "Representative",
    ktg_representative_full_name: "Full name",
    ktg_representative_job_title: "Job title",
    ktg_acting_basis: "Acting basis",
    ktg_place: "Document place",
    ktg_attorney_issued_before: "Attorney issued before",
    ktg_attorney_wagon_id: "Wagon id",
    ktg_attorney_wagon_number: "Wagon number",
    ktg_attorney_wagons_list: "Wagons list",

    ktg_attorney_add_wagon: "Add wagon",
    ktg_wagon_number: "Wagon number",
    ktg_act_basis_placeholder: "Charter",

    pdf_insurance: "Cargo insurance",
    pdf_insurance_no_logo: "Cargo insurance (No logo)",
    insurance_pdf_title: "APPLICATION - QUESTIONNAIRE",
    insurance_pdf_subtitle: "to conclude a cargo insurance contract",
    insurance_pdf_subsubtitle:
      "Please endorse any corrections and additions. Please fill in capital letters.",
    insurance_pdf_footer_title: "Declaration of the Insured:",
    insurance_pdf_p_1:
      'By signing this application form, as well as the insurance contract, the Policyholder gives the Insurer (including the Insurer`s parent organization and subsidiaries of the Insurer`s parent organization) its consent to the collection and processing of personal data in accordance with the Law of the Republic of Kazakhstan "On Personal Data and their Protection", including the accumulation , use, change (addition, update), storage, distribution, depersonalization, blocking, destruction of personal data, as well as their consent to communicate with the Policyholder, including receiving newsletters. Consent is considered valid if it is not revoked at the written request of the Insured.',
    insurance_pdf_p_2:
      "The insurer has the right to verify the accuracy of the personal data provided, including using other available sources.",
    insurance_pdf_p_3:
      "I hereby declare that the information specified in the Application-questionnaire is correct and does not contain false information or any inaccuracies, and I have provided all essential information in accordance with the requirement of the Insurer. I am also aware of the consequences for providing false information about the object of insurance, the insured risk, the insured event and its consequences.",
    insurance_pdf_p_4:
      "I also confirm that this Application-questionnaire will serve as the basis for the conclusion of the Insurance Contract.",
    insurance_pdf_p_5:
      'I have read/received a copy of the Rules for Voluntary Cargo Insurance of JSC "Insurance Company "{{company}}".',
    insurance_pdf_p_6_b: "Notification.",
    insurance_pdf_p_6:
      "The Insurer reserves the right to terminate the Insurance Policy and/or refuse to make an insurance payment if the Policyholder hereby provided false information or concealed any material information in order to conclude the Insurance Policy, as well as on the grounds provided for by the Law of the Republic of Kazakhstan “On combating the legalization (laundering) of proceeds from crime and the financing of terrorism”.",
    insurance_pdf_insurer: "Policyholder",
    insurance_pdf_signature: "Signature",
    insurance_pdf_date: "the date",
    insurance_pdf_footer1: "Insurance premium rate",
    insurance_pdf_footer2: "The insurance payment is calculated in the amount",
    insurance_pdf_footer3: "Representative of JSC Insurance Company",
    insurance_pdf_0: "Name of the Policyholder:",
    insurance_pdf_1: "represented by (full name, position):",
    insurance_pdf_1: "Legal address:",
    insurance_pdf_1: "The actual address:",
    insurance_pdf_1:
      "Are you a foreign public person (to be completed, individual or individual entrepreneur)?",
    insurance_pdf_1: "Details of the Insured:",
    insurance_pdf_2: "Type of activity of the Insured:",
    insurance_pdf_3: "Beneficiary:",
    insurance_pdf_4: "Details of the Beneficiary:",
    insurance_pdf_5: "Shipping Name:",
    insurance_pdf_6:
      "Information about the type of packaging and special protective coatings:",
    insurance_pdf_7:
      "The cost of cargo in one package and (or) in one special cover:",
    insurance_pdf_8:
      "Number of packages and (or) objects in special protective coatings:",
    insurance_pdf_9: "The total cost of the consignment:",
    insurance_pdf_10: "Date of issue (production) of the cargo:",
    insurance_pdf_11: "Containerization: Complete?",
    insurance_pdf_12:
      "Describe the way (method) of cargo placement and the number of containers (wagons, trailers, bulk, bulk, etc.):",
    insurance_pdf_13:
      "Route: (indicate the details of the exact route of transportation, as well as the points of transshipment and transshipment, including the warehouse of departure and warehouse of destination):",
    insurance_pdf_14: "Security measures taken:",
    insurance_pdf_15:
      "Transportation of goods is carried out by means of (mode of transport):",
    insurance_pdf_16:
      "Transfer points where it is planned to change the type of vehicle (also indicate all temporary storage warehouses):",
    insurance_pdf_17: "Details of shipping documents:",
    insurance_pdf_18: "Insured risks:",
    insurance_pdf_19: 'Condition A "With responsibility for all risks"',
    insurance_pdf_20: 'Condition B "With liability for a partial accident"',
    insurance_pdf_21: 'Condition B "No liability for damages"',
    insurance_pdf_22: "Additional terms:",
    insurance_pdf_23: "Maximum insured value of cargo:",
    insurance_pdf_24: "A) in one container",
    insurance_pdf_25: "B) in one vehicle",
    insurance_pdf_26: "B) on the same ship",
    insurance_pdf_27: "D) on one aircraft",
    insurance_pdf_28: "D) on one railway car",
    insurance_pdf_29: "E) in one place of storage",
    insurance_pdf_30: "The sum insured includes transport and insurance costs.",
    insurance_pdf_31: "If YES, please indicate the amount:",
    insurance_pdf_32: "Sum insured (for consignment):",
    insurance_pdf_33: "Franchise:",
    insurance_pdf_34: "Shipment date:",
    insurance_pdf_35: "Time spent on the way",
    insurance_pdf_36:
      "Provide statistical data on any insured events that have occurred with your cargo over the past three years (cargo value, losses incurred, etc.):",
    insurance_pdf_37:
      "Please provide any information that you think is relevant to this risk:",
    insurance_pdf_38: "Other:",

    document_specification: "Specification",
    document_specification_no_logo: "Specification (No logo)",
    specifications_spec_number: "Specification number",
    specifications_spec_place: "Place of subscription",
    specifications_spec_date: "Date",
    spec_good_name: "Product name",
    spec_good_orign: "country of origin",
    spec_good_manufacturer: "Producer name",
    spec_good_model: "Product model",
    spec_good_mark: "Product marking",
    spec_good_serialnum: "Serial number",
    spec_good_man_year: "Year of production",
    spec_good_curr: "Currency",

    form_m: "Form M",
    invoice: "Invoice",
    cmr: "CMR",
    specification: "Specification",
    fm1: "FM-1",
    epi: "EPI",
    awb: "AWB",
    rwb: "RWB",
    insurance: "Insurance",
    "liability-insurance": "Liability insurance",
    packaging: "Packaging",
    sad: "SAD",
    ktg_attorney: "KTZH",
    download_pdf: "Download PDF",
    download_pdf_no_logo: "Download PDF (No logo)",
  },
  help: {
    registration: "User registration",
    document: "Documents",
    transport_offer: "Transportation request",
    contract_offer: "Contract offers",
    contract_signature: "Contract signing",
    new_contract: "Contract application",
    contract_add_contragent: "Contract adding counterparty",
    pa_personal: "Personal are",
    pa_legal: "Personal area of legal entity",
    contragent_check: "Search and verification of a counterparty",
    export_import: "Export Import",
    epi: "EPI",
    ca: "check partner",
    "contract-new": "Create new contract",
  },
  navigation: {
    never_show_again: "Don't show again",
    registration: "First you need to register",
    register: "Register",
    auth: "Now you need to pass authorization",
    login: "Come in",
    search_partner: "Search for a partner",
    find_a_partner:
      "You need to find a partner according to the selected parameters",
    check_partner: "Check partner",
    find_a_partner_message:
      'To search for a partner, select the required options and click "Search"',
    find_a_partner_message_result:
      'You need to tick the partner you want to check and click "check"',
    next_create_contract:
      'After checking the partner, you need to create a contract. To do this, go to the section "Contracts"',
    create_contract: "Create a contract",
    to_create_contract_message:
      'To create a contract, click the "Create contract" button',
    save_contract_message:
      'After filling out the contract - save it by clicking on "Save contract"',
    save_contract: "Save contract",
    open_contract_message: "Contract created, open it",
    open_contract: "Open contract",
    sign_contract_message: "Now the contract needs to be signed",
    sign_contract: "Sign contract",
    contract_offers_message: "Create or view contract proposals",
    create_offer: "Open",
    contract_couriers_message: "Create or view transportation offers",
    contract_brokers_message: "Create or view broker offers",
    contract_docs_message:
      "Create an Invoice, Packing list, Waybills, Insurance, then go to the EXIM tab",
    create_documents: "Create Documents",
    contract_docs_invoice_message: "Start creating documents from an invoice",
    create_invoice: "Create Invoice",
    contract_docs_packing_list_message: "Now you need to create a packing list",
    create_packing_list: "Create Packing List",
    contract_docs_cmr_message: "Теперь создайте CMR",
    create_cmr: "Create a CMR",
    contract_docs_insurance_message: "Now you need to create cargo insurance",
    create_insurance: "Create insurance",
    contract_docs_liability_insurance_message:
      "Now create your civil liability insurance",
    create_liability_insurance: "Create insurance",
    contract_docs_exim_message: "Now go to Exim",
    create_exim_insurance: "Go",
  },
  admin: {
    settings: "Settings",
    business_score_default_year: "Business Score Default Year",
    current_default_year: "Current default year",
    serviceprices: "Services pricelist",
    service_code: "Code",
    service_name: "Serice name",
    service_price: "Price",
    actions: "Actions",
    add_service: "Add service",
    edit_service: "Edit service",

    active: "Registration",
    registrations: "Registrations",
    users: "Users",
    logs: "logs",
    operations: "Operations",
    index: "Admin Panel",
    lock_user: "Disable",
    unlock_user: "Enable",
    oper_code: "Operation",
    log_source_user_id: "Event initiator user",
    log_target_user_id: "User event target",
    doc_id: "Document",
    stop: "Stop",
    start: "Launch",
    request_date: "Application date",
    attis_status: "ATTIS in mode",
    stop_confirmation: "Attention ! ATTIS system will be stopped",
    start_confirmation:
      "Attention ! The ATTIS system will be put into working condition",
    registration_approved: "Application approved",
    log_date: "Date of operation",
    is_error: "Error",
    data: "Data",

    "toc-offers": "Offers",
    "toc-offer-active": "Active",
    "toc-offer-inactive": "Not active",
    download: "Download",
    offer_file: "Offer file",
    offer_diff: "Changes in the offer",
    offer_start_date: "Effective date",
    offer_end_date: "End date",
    offer_status: "Status",
    "ca-history": "Comply Advantage history",

    ca_history_date_from: "Date from",
    ca_history_date_to: "Date to",
    ca_history_organisation: "Organisation",
    search_query: "Request",
    search_date: "Date",
    ca_search_id: "Id",
    history_pdf: "Response",
    translations: {
      translations: "Translations",
      service_code: "Service code",
      category: "Category",
      field_name_cn: "Field Name (CN)",
      field_data_cn: "Field Data (CN)",
      field_name_ru: "Field Name (RU)",
      field_data_ru: "Field Data (RU)",
      field_name_en: "Field Name (EN)",
      field_data_en: "Field Data (EN)",
      error_json: "Error: Backend response is not JSON serializable",
      add: "Add",
      edit: "Edit",
      delete: "Delete",
      add_translation: "Add translation",
      edit_translation: "Edit translation",
    },
    admin_user_balance: { 
      user_balance: "User balance", 
      operation_history: "User operation history", 
      row_no: "No.", 
      user: "Company name", 
      organization: "Organization", 
      total_top_up: "Total top-up, tenge", 
      total_spent: "Total spent, tenge", 
      balance: "Balance, tenge", 
      last_operation_date: "Last operation", 
      operation_date: "Date", 
      operation_type: "Operation", 
      amount: "Amount, tenge", 
      service_code: "Service code", 
      service_name: "Service name", 
      search_keyword: "Search keyword", 
      has_results: "Has results", 
      request_id: "Request ID",
      yes: "Yes",
      no: "No",
      organization_name: "Organization name",
      api_request: "API request",
    }
  },
  validation: {
    PA1_Addr_W_001_name: "Having a legal address",
    PA1_Addr_W_001_message: "Postal code not provided",

    PA1_Addr_W_002_name: "Having a legal address",
    PA1_Addr_W_002_message: "Country of residence not specified",

    PA1_Addr_W_003_name: "Having a legal address",
    PA1_Addr_W_003_message:
      "Region (Name of the unit of administrative-territorial division of the first level) is not specified",

    PA1_Addr_W_004_name: "Having a legal address",
    PA1_Addr_W_004_message: "Region not specified",

    PA1_Addr_W_005_name: "Having a legal address",
    PA1_Addr_W_005_message: "City not specified",

    PA1_Addr_W_006_name: "Having a legal address",
    PA1_Addr_W_006_message: "Locality not specified",

    PA1_Addr_W_007_name: "Having a legal address",
    PA1_Addr_W_007_message: "Street not specified",

    PA1_Addr_W_008_name: "Having a legal address",
    PA1_Addr_W_008_message:
      "The designation of the house, building, building is not indicated",

    PA1_Addr_W_009_name: "Having a legal address",
    PA1_Addr_W_009_message:
      "The designation of the office or apartment is not indicated",
    PA1_Fndr_W_001_name: "Founders",
    PA1_Fndr_W_001_message: "No information about the founders",

    PA1_Acc_W_002_name: "Accounts",
    PA1_Acc_W_002_message: "No bank account details",

    PA1_Main_E_001_name: "Name",
    PA1_Main_E_001_message: "No company name",

    PA1_Main_W_002_name: "OKED",
    PA1_Main_W_002_message: "OKED not specified",

    PA1_Main_W_003_name: "type of organization",
    PA1_Main_W_003_message: "Organization type not specified",

    PA1_Main_W_004_name: "Contacts",
    PA1_Main_W_004_message: "Company contacts not specified",

    PA1_Main_W_005_name: "Country of registration",
    PA1_Main_W_005_message: "Country of residence not specified",

    PA2_Main_W_001_name: "Residence",
    PA2_Main_W_001_message: "Country of residence not specified",

    PA2_Main_W_002_name: "EDS",
    PA2_Main_W_002_message: "EDS not loaded",

    CN1_Main_W_001_name: "Topic",
    CN1_Main_W_001_message: "The subject of the contract is not specified",

    CN1_Main_W_002_name: "Description",
    CN1_Main_W_002_message: "Contract description not specified",

    CN1_Main_W_003_name: "Goods",
    CN1_Main_W_003_message: "The goods are not specified in the contract",

    CN1_Main_W_004_name: "Buyer",
    CN1_Main_W_004_message:
      "The counterparty under the contract was not specified",
    Inv_Main_E001_name: "Date of invoice",
    Inv_Main_E001_message: "Invoice date not specified",

    Inv_Main_E002_name: "Invoice currency",
    Inv_Main_E002_message: "Invoice currency not specified",

    Inv_Main_W003_name: "Invoice and contract currency",
    Inv_Main_W003_message: "Invoice and contract currencies do not match",

    Inv_Main_W004_name: "Invoice gross weight",
    Inv_Main_W004_message: "Gross weight not specified",

    Inv_Main_W005_name: "Invoice net weight",
    Inv_Main_W005_message: "Net weight not specified",

    Inv_Main_W006_name: "Invoice total cost",
    Inv_Main_W006_message: "No total cost",

    Inv_Goods_E001_name: "Contract value and sum of total invoice values",
    Inv_Goods_E001_message:
      "The cost of the contract and invoices do not match",

    Inv_Goods_E002_name: "Commercial name of invoice and contract goods",
    Inv_Goods_E002_message:
      "The commercial name of the goods of the contract and invoices do not match",

    Inv_Goods_E003_name: "HS Code code of invoice and contract goods",
    Inv_Goods_E003_message:
      "HS Code codes of contract goods and invoices do not match",

    Inv_Goods_E004_name: "Quantity of invoice and contract items",
    Inv_Goods_E004_message:
      "The quantity of goods in the contract and invoices do not match",

    Inv_Goods_E005_name: "Invoice and contract goods prices",
    Inv_Goods_E005_message:
      "The prices of goods in the contract and invoices do not match",

    Inv_Goods_E006_name: "Buyer of the contract and invoice",
    Inv_Goods_E006_message: "Buyer contract and invoices do not match",

    Inv_Goods_E007_name: "Seller of the contract and invoice",
    Inv_Goods_E007_message: "Seller contract and invoices do not match",

    PL_Pack_Main_E001_name: "Gross weight of goods",
    PL_Pack_Main_E001_message:
      "The gross weight of the goods does not match the invoice",

    PL_Pack_Main_E002_name: "Net weight of goods",
    PL_Pack_Main_E002_message:
      "The net weight of the goods does not match the invoice",

    PL_Pack_Main_E003_name: "Quantity of goods",
    PL_Pack_Main_E003_message:
      "The quantity of goods in the packing list and the contract do not match",

    PL_Pack_Main_E004_name: "Number of seats",
    PL_Pack_Main_E004_message:
      "The number of places of goods in the packing list and invoice do not match",
    AP_Goods_W002_name: "Number of items of goods",
    AP_Goods_W002_message:
      "The number of goods in the invoice and EPI do not match",

    AP_Goods_W003_name: "Product weight",
    AP_Goods_W003_message:
      "The gross weight of the goods does not match the invoice",

    AP_Goods_W004_name: "Total number of packages",
    AP_Goods_W004_message:
      "The total number of packages in the EPI does not match the Packing lists",

    AP_Goods_W005_name: "",
    AP_Goods_W005_message: "",

    CMR_Main_W001_name: "CMR sender",
    CMR_Main_W001_message: "Contract Seller and CMR do not match",

    CMR_Main_W002_name: "CMR Recipient",
    CMR_Main_W002_message: "Buyer of the contract and CMR do not match",

    CMR_Goods_E001_name: "Cargo weight CMR",
    CMR_Goods_E001_message:
      "The gross weight of the goods does not match the invoice",

    CMR_Goods_E002_name: "CMR Freight Cost",
    CMR_Goods_E002_message: "",

    CMR_Main_W003_name: "Number of goods",
    CMR_Main_W003_message: "quantity of goods in CMR and contract do not match",

    CMR_Main_W004_name: "Number of packages",
    CMR_Main_W004_message:
      "The number of packages in the packing list does not match the packages in the CMR",

    validate_fix_button: "Fix",

    CN1_Main_W_100_name: "Goods",
    CN1_Main_W_100_message: "Goods are not set in the Form M",

    // CN1_Main_W_001_name: 'Form M GUID',
    // CN1_Main_W_001_message: 'Form M GUID not set',
    // CN1_Main_W_002_name: 'Form M Type',
    // CN1_Main_W_002_message: 'Form M type not set',
    // CN1_Main_W_003_name: 'Valid Forex',
    // CN1_Main_W_003_message: 'Valid Forex not set',
    // CN1_Main_W_004_name: 'Form M Number',
    // CN1_Main_W_004_message: 'Form M Number not set',
    // CN1_Main_W_005_name: 'Form Prefix',
    // CN1_Main_W_005_message: 'Form M Prefix not set',
    // CN1_Main_W_006_name: 'Form M Year',
    // CN1_Main_W_006_message: 'Form M Year not set',
    // CN1_Main_W_007_name: 'Form Number',
    // CN1_Main_W_007_message: 'Form Number not set',
    // CN1_Main_W_008_name: 'User',
    // CN1_Main_W_008_message: 'Form M user not set',
    CN1_Main_W_001_name: "TIN",
    CN1_Main_W_001_message: "TIN unset",
    CN1_Main_W_002_name: "Country of residence",
    CN1_Main_W_002_message: "Country of residence is not set",
    CN1_Main_W_003_name: "Applicant name",
    CN1_Main_W_003_message: "Please degine the name of applicant",
    CN1_Main_W_004_name: "Applicant address",
    CN1_Main_W_004_message: "Please define applicant`s address",
    CN1_Main_W_005_name: "Applicant city",
    CN1_Main_W_005_message: "Please define applicant`s city",
    CN1_Main_W_006_name: "Applicant`s phone",
    CN1_Main_W_006_message: "Applicant`s phone is not defined",
    CN1_Main_W_007_name: "Applicant`s Email",
    CN1_Main_W_007_message: "Plesase define applicant`s Email",
    CN1_Main_W_008_name: "Traportation country",
    CN1_Main_W_008_message: "Transportation country is not set",
    CN1_Main_W_009_name: "Loading port",
    CN1_Main_W_009_message: "Loading port is not set",
    CN1_Main_W_010_name: "Destination point",
    CN1_Main_W_010_message: "Destination point is not set",
    CN1_Main_W_011_name: "Transportation mode",
    CN1_Main_W_011_message: "Transportation mode is not set",
    CN1_Main_W_012_name: "Dispatching country",
    CN1_Main_W_012_message: "Please define dispatching country",
    CN1_Main_W_100_name: "Goods",
    CN1_Main_W_100_message: "Please define goods",
    CN1_Main_W_101_name: "Net-Weight",
    CN1_Main_W_101_message: "Please define net weight",
  },

  homepage: {
    eurasia: "EURASIA",
    crossborder_link: "To the portal",
    menu_main: "Main",
    menu_about_us: "About us",
    menu_services: "Services",
    menu_news: "News",
    tarif: "Prices",
    menu_our_team: "Our team",
    menu_contacts: "Contacts",
    personal_area_btn: "Personal area",
    attis_full_name: "Automated transborder trade integrated settlements",
    attis_subline_name: "Platform integrating Russia with China",
    attis_description:
      'International digital platform for the provision of a full range of information services on the principle of "Single page" to all participants in foreign economic activity',
    watch_video: "Watch video",
    section_about_us: "ABOUT US",
    about_us_p1:
      "The implementation of the ATTIS project in the Republic of Kazakhstan began in March 2020, when, on behalf of the Prime Minister of the Republic of Kazakhstan, an Interdepartmental Working Group was created, the work of which was coordinated by the Ministry of Trade and Integration of the Republic of Kazakhstan. The ATTIS project is based on advanced IT technologies that allow for effective adaptation with public and private information systems, as well as rapid implementation of the project.",
    about_us_p2:
      "The structure of the ATTIS project consists of regional ATTIS centers located in Europe, China and the Republic of Kazakhstan. Each regional ATTIS center is certified by the countries in which they operate.",
    about_us_p3:
      "The participant and owner of the ATTIS project is CrossborderXP, LTD (CBXP), headquartered in Dublin (Ireland). CrossborderXP, LTD (CBXP) has extensive experience in finance, logistics, customs procedures and business management. As the owner of the ATTIS project, CrossborderXP, LTD (CBXP) is responsible for the development of the project and its global implementation.",
    about_us_p4:
      "As part of the One Belt, One Road project, the ATTIS project received administrative support as well as initial funding from the PRC government (Ministry of Commerce of the PRC) to initiate the development and pilot implementation of the ATTIS project with partner countries. The ATTIS system is integrated with China's exportimport.com system, which is a global database of exporters and importers of China, covering more than one million Chinese companies today. Such integration gives participants in foreign economic activity the opportunity to choose offers that are suitable in terms of price and quality and will make it possible to conclude transactions directly in the ATTIS system.",
    about_us_p5:
      "The mission of the ATTIS project is to create a global and competitive platform that unites all participants in foreign economic activity on both sides of the border, in one information space to provide a full range of information and other services on a one-stop basis.",
    about_us_list_title: "Advantages of the ATTIS project:",
    about_us_list_i1:
      "transparency, efficiency and availability of information on foreign economic activity for all its participants;",
    about_us_list_i2: "trade facilitation and improved international ratings;",
    about_us_list_i3:
      "increasing transparency and reliability in conducting foreign economic transactions;",
    about_us_list_i4:
      "an opportunity for participants in foreign economic activity to simplify the submission of information to state bodies;",
    about_us_list_i5:
      "reduction of time and financial costs of participants in foreign economic activity;",
    about_us_list_i6:
      "the possibility for participants in foreign economic activity to search for foreign contractors and partners in trusted sources of information, as well as to check their reliability using the international ComplyAdvantage system.",
    about_us_p6:
      "The target audience of the ATTIS project includes exporters, importers, transport and logistics companies, customs brokers, commercial banks, insurance organizations, government agencies, authorized organizations for certification of origin, as well as other participants in foreign economic activity.",
    our_team_section: "Our team",
    our_team_description:
      "The leaders of the international ATTIS group, who stood at the origins of the development and creation of the ATTIS project, are:",
    leader_edward: "EDWARD BOWEN",
    leader_edward_job_title: "Chief Executive",
    leader_edward_description:
      "Edward was an officer in the British Army for more than 20 years where his work enabled him to develop his knowledge of planning and organization. On leaving the Army in 1994 he worked in Latvia where he established companies dealing in logistics of fresh and frozen food products from the USA and Ecuador into the neighboring countries and as far as Kazakhstan. On selling these companies he developed a number of real estate parks in Latvia with major international clients. One of these sites near the border with Russia, in the Free Economic Zone of Rezekne, remains a focus for further development of the overland routes along the Belt and Road. Edward was the first Chairman of the British Chamber of Commerce in Latvia in 1997 and a founder of the Foreign Investors Council in Latvia. He has worked with Sergei for more than a decade that lead to the establishment of CrossborderXP.",
    leader_michael: "MICHAEL J BOURKE",
    leader_michael_job_title: "Managing Partner Finance and Banking",
    leader_michael_description:
      "has over 40 years experience of banking. At the start of his career after completing several assignments with the Central Bank of Ireland he was appointed to the International Monetary Fund where he worked in Uganda and Egypt. This was followed by 5 years with the EU-EC Phare program, 1992-1997, as advisor in the Central Bank in Latvia. He was the CEO and President of Rietumu Bank in Latvia from 1997-2006. In 2009 he was requested by the Government of Latvia/EBRD to assist in the recovery of Parex Bank and remained Chairman until 2017 with more than 70% of the funds recovered. With broad international experience Michael has been an independent non executive director of both the Bank of Nova Scotia (Ireland) and State Street Bank Ireland. Michael was the Honorary Consul for Ireland in Latvia 1998-2006. More recently he has been one of the founding members of CROSSBORDERXP.",
    leader_sergey: "SERGEI NIKOLAYEV",
    leader_sergey_job_title: "Systems Architect",
    leader_sergey_description:
      "has 7 officially registered intellectual properties in software development technology and system implementation. About 25 e-government, e-banking, e-customs projects development, implementation and support. High-level expert, more than 25 years acting as project lead and CEO in different countries where all his projects were implemented (Kazakhstan, Russia, USA, Lithuania, Belarus, Ukraine and China etc.)",
    leader_aben: "ABEN BEKTASOV",
    leader_aben_job_title: "Managing Partner Central Asia",
    leader_aben_description:
      "has held top management positions in wide range of government structures and organizations in Kazakhstan for more than 30 years (National Bank, Ministry of Finance, Securities National Committee, KazakhTelecom, National Agency for IT and Telecommunications, National Security Committee) . As a deputy chairman of Kazakhstan National Bank he was responsible in interbank settlements system development, payment systems development and also pension reform implementation. As a result, the national interbank settlements system and pension system recognized by World Bank as the most efficient system in post-USSR.",
    leader_erzhan: "YERZHAN TOKTABAYANOV",
    leader_erzhan_job_title: "Director of ATTIS Eurasia LLP",
    leader_erzhan_description:
      'Yerzhan has more than 17 years of experience in banking and insurance spheres where he held senior positions in legal service, compliance control and financial monitoring departments. The main tasks in these positions were legal support of the bank`s activity, including control over the bank`s compliance with anti-money laundering and counter-terrorism financing legislation, representation of the bank in the National Bank of the Republic of Kazakhstan, the "Association of Financiers of Kazakhstan" and other state bodies. Yerzhan is a consultant of IFC and the World Bank on corporate governance. Within the framework of these activities, he participated in the implementation of the project on implementation of corporate governance system in the leading financial institutions of the Republic of Tajikistan.',
    section_our_partners: "OUR PARTNERS",
    services_and_prices: "Services and Rates",
    customer_categories: "OUR CUSTOMERS",
    customer_categories_description:
      "The System unites all participants of foreign economic activity, including state and customs authorities on both sides of the border",
    read_more: "Read more",
    show_more: "Show more services",
    show_less: "Show less services",
    attis_features: "<strong>ATTIS INFORMATION SYSTEM</strong> FEATURES",
    news: "News",
    contacts: "Contacts",
    headquarters: "Headquarters",
    address:
      'NUR-SULTAN, DISTRICT "ESIL", STREET DINMUHAMED KONAEV, BUILDING 4',
    phone: "Phone",
    name: "Your name",
    email: "Your Email",
    subject: "Subject",
    message: "Message",
    sending: "Sending",
    thankyou: "Thank you for your message",
    send: "Send",
    gotoaccount: "Navigate to pesonal area",
    gotoaccount_text: "Sign up in ATTIS System right now.",
    nursultan: "NUR-SULTAN",
    yesil: 'DISTRICT "ESIL"',
    street: "STREET DINMUHAMED KONAEV",
    building: "BUILDING 4",
    kz: "Kazakhstan",
  },
  comply_advantage: {
    tippy: "To continue monitoring, turn on the switch",
    search_tab: "Search",
    case_management_tab: "Case Management",
    name_details: "Name and details",
    details_name: "Name",
    details_reference: "Client reference (optional)",
    details_reference_placeholder: "XXXX",
    details_birth_year: "Year of Birth (optional)",
    details_birth_year_placeholder: "YYYY",
    details_country: "Country (optional)",
    entity_type_title: "Entity Type",
    entity_type_all: "All",
    entity_type_person: "Person",
    entity_type_company: "Company",
    entity_type_organisation: "Organisation",
    entity_type_vessel: "Vessel",
    entity_type_aircraft: "Aircraft",
    fuzzy_exact: "Exact Match",
    fuzziness_title: "Fuzziness",
    fuzzy_0: "0%",
    fuzzy_10: "10%",
    fuzzy_20: "20%",
    fuzzy_30: "30%",
    fuzzy_40: "40%",
    fuzzy_50: "50%",
    fuzzy_60: "60%",
    fuzzy_70: "70%",
    fuzzy_80: "80%",
    fuzzy_90: "90%",
    fuzzy_100: "100%",

    filter_date_from: "Created from",
    filter_date_to: "Created to",
    filter_name: "Search name",
    filter_reference: "Search reference",
    filter_match: "Match status",
    filter_risk: "Risk level",
    filter_assigned_to: "Assigned to",
    filter_searched_by: "Searched by",
    filter_changed: "Changed",
    filter_monitored: "Monitored",
    filter_matched: "Match Types",

    filter_match_all: "All",
    filter_match_unknown: "Unknown",
    filter_match_no: "No Match",
    filter_match_potential: "Potential Match",
    filter_match_false_positive: "False Positive",
    filter_match_true_positive: "True Positive",
    filter_match_true_positive_approve: "True Positive - Approve",
    filter_match_true_positive_reject: "True Positive - Reject",

    filter_risk_all: "All",
    filter_risk_unknown: "Unknown",
    filter_risk_low: "Low",
    filter_risk_medium: "Medium",
    filter_risk_high: "High",

    filter_changed_all: "All",
    filter_changed_changed: "Changed",
    filter_changed_unchanged: "Unchanged",

    response_match_enrichment: "Enrichment",
    filter_monitored_all: "All",
    filter_monitored_actively: "Actively Monitored",
    filter_monitored_suspended: "Suspended",
    filter_monitored_unmonitored: "Unmonitored",

    filter_matched_types_all: "All",
    filter_matched_types_sanctions: "Sanctions",
    filter_matched_types_warnings: "Warnings",
    filter_matched_types_fitness_probity: "Fitness & Probity",
    filter_matched_types_peps_all: "PEPs",
    filter_matched_types_pep_1: "PEP Class 1",
    filter_matched_types_pep_2: "PEP Class 2",
    filter_matched_types_pep_3: "PEP Class 3",
    filter_matched_types_pep_4: "PEP Class 4",
    filter_matched_types_adverse_media: "Adverse Media",
    filter_matched_types_financial_crime: "Financial Crime",
    filter_matched_types_violent_crime: "Violent Crime",
    filter_matched_types_sexual_crime: "Sexual Crime",
    filter_matched_types_terrorism: "Terrorism",
    filter_matched_types_fraud: "Fraud",
    filter_matched_types_narcotics: "Narcotics",
    filter_matched_types_other: "Other Crime",

    table_created: "Created",
    table_names: "Search term",
    table_ref: "Ref",
    table_match_status: "Match Status",
    table_risk_level: "Risk level",
    table_assigned_to: "Assigned To",
    table_searcher: "Searcher",
    table_changes: "Changes",
    table_changed: "Changed",
    table_monitor: "Monitor",

    apply_filters: "Apply Filters",
    remove_filters: "Remove Filters",

    matched_label: "Matched",
    relevance_label: "Relevance",
    countries_label: "Countries",
    dob_label: "DOB",

    response_entity_type_organisation: "Organisation",
    response_entity_type_person: "Person",
    response_entity_type_company: "Company",
    response_entity_type_vessel: "Vessel",
    response_entity_type_aircraft: "Aircraft",

    response_match_sanction: "Sanctions",
    response_match_warning: "Warnings",
    response_match_pep: "PEP",
    "response_match_pep-class-1": "PEP Class 1",
    "response_match_pep-class-2": "PEP Class 2",
    "response_match_pep-class-3": "PEP Class 3",
    "response_match_pep-class-4": "PEP Class 4",

    "response_match_fitness-probity": "Fitness & Probity",
    "response_match_adverse-media": "Adverse Media",
    "response_match_adverse-media-financial-crime": "Financial Crime",
    "response_match_adverse-media-violent-crime": "Violent Crime",
    "response_match_adverse-media-sexual-crime": "Sexual Crime",
    "response_match_adverse-media-terrorism": "Terrorism",
    "response_match_adverse-media-fraud": "Fraud",
    "response_match_adverse-media-narcotics": "Narcotics",
    "response_match_adverse-media-general": "Other Crime",

    response_relevance_name_exact: "Name matched exactly",
    response_relevance_aka_exact: "Aka matched exactly",
    response_relevance_name_fuzzy: "Name matched closely",
    response_relevance_aka_fuzzy: "Aka matched closely",
    response_relevance_phonetic_name: "Name matched phonetically",
    response_relevance_phonetic_aka: "Aka matched phonetically",
    response_relevance_equivalent_name: "Name matched with a synonym",
    response_relevance_equivalent_aka: "Aka matched with a synonym",
    response_relevance_unknown: "Complex match",
    response_relevance_year_of_birth: "Year of birth matched",
    response_relevance_removed_personal_title: "Removed personal title",
    response_relevance_removed_personal_suffix: "Removed personal suffix",
    response_relevance_removed_organisation_prefix:
      "Removed organisation prefix",
    response_relevance_removed_organisation_suffix:
      "Removed organisation suffix",
    response_relevance_removed_clerical_mark: "Removed clerical mark",

    case_deleted_successfully: "Case deleted successfully",
    case_delete_unsuccessful: "Error deleting case",

    search_no_results: "No results!",
    filter_countries_all: "All",

    check_differences: "Check differences",

    on_off_monitor: "Switch monitoring",
    only_monitored: "Only monitored requests",

    show_additional_params: "Show additional params",
    hide_additional_params: "Hide additional params",
  },
  find_partner: {
    no_results_found: "No results found",
    history: "History",
    cn: "China",
    kz: "Kazakhstan",
    ru: "Russia",
    search_keyword: "Unified social credit code, Registration number",
    search_button: "Search",
    find_all_companies: "Load all companies",
    max_pages: "Pages",
    table_field: "Field",
    table_value: "Value",
    table_value_cn: "Value Chinese",
    all_services_cn: "All services CN",
    common_info_cn: "Company information",
    common_info_cn_no_logo: "Company information (No logo)",
    common_info_name_list: "Used names",
    common_info_name_list_name: "Name",
    common_info_name_list_date: "Change date",
    common_info_share_holder_list: "Shareholders",
    common_info_share_holder_KeyNo: "Key No",
    common_info_share_holder_StockName: "Stock list",
    common_info_employee_list: "Employees",
    common_info_employee_KeyNo: "KeyNo",
    common_info_employee_Name: "Name",
    common_info_employee_Job: "Job",
    common_info_invest_list: "Investors",
    common_info_invest_list_Name: "Name",
    common_info_invest_list_KeyNo: "KeyNo",
    common_info_invest_list_RegistCapi: "Capital",
    common_info_invest_list_StartDate: "StartDate",
    common_info_invest_list_Status: "Status",
    common_info_invest_list_OperName: "Representative",
    common_info_change_list: "Change record information",
    common_info_change_list_ProjectName: "Project Name",
    common_info_change_list_BeforeList: "Before",
    common_info_change_list_AfterList: "After",
    common_info_change_list_ChangeDate: "Date of change",
    common_info_branch_list: "Branch information",
    common_info_branch_list_KeyNo: "KeyNo",
    common_info_branch_list_Name: "Name",
    common_info_branch_list_DirectorName: "Director Name",
    common_info_branch_list_Status: "Status",
    common_info_more_email_list: "More mailboxes",
    common_info_more_email_list_Source: "Source",
    common_info_more_email_list_Value: "Value",
    common_info_more_tel_list: "More telephones",
    common_info_more_tel_list_Source: "Source",
    common_info_more_tel_list_Value: "Value",
    common_info_ent_tag_list: "Enterprise tag",
    common_info_ent_tag_list_Type: "Type",
    common_info_ent_tag_list_Name: "Name",
    common_info_Province: "Province",
    common_info_Grade: "Grade",
    common_info_GradeDescription: "Grade description",
    common_info_as_calculated_grade: "How the grade was calculated?",
    cn_company_info_check_alert:
      "Attention! China company information verification is a paid service. The price is ",

    cn_single_service_alert: "Attention! {} is a paid service. The price is ",
    cn_bulk_services_alert: "Attention! {} are paid services. The price is ",

    no_results:
      "No matches for services [services] request with parameters [parameters]",
    no_results_430: "No results found",
    court_notice_info: "Court Notice Verification",
    court_notice_info_no_logo: "Court Notice Verification (No logo)",
    court_notice_Id: "Id",
    court_notice_CaseNo: "Case Number",
    court_notice_CaseReason: "Case Reason",
    court_notice_Category: "Category",
    court_notice_Court: "Court",
    court_notice_PublishDate: "Publish date",
    court_notice_ProcecutorList: "Prosecutor list",
    court_notice_DefendantList: "Defendant list",

    corporate_news_search: "Corporate News Search",
    corporate_news_search_no_logo: "Corporate News Search (No logo)",
    corporate_news_search_Id: "ID",
    corporate_news_search_NewsId: "NewsId",
    corporate_news_search_Source: "Source",
    corporate_news_search_Title: "Title",
    corporate_news_search_Url: "Url",
    corporate_news_search_PublishTime: "Publish Time",
    corporate_news_search_EmotionType: "Emotion Type",
    corporate_news_search_Category: "Category",
    corporate_news_search_NewsTags: "News Tag",
    corporate_news_search_Content: "Content",

    area_table: "Area",
    industry_table: "Industry",
    revoke_info_table: "Revokation Information",
    parent_info_table: "Head Office Information",

    main_service_cn: "Services",
    main_service_description:
      "This service contains company information and Court Notice Verification",
    load_in_progress: "Please wait. Data is loading, it can take some time.",
    common_info_cn_description:
      "Description: The interface covers business-to-business face-to-face information, such as business name, registration status, registered capital, unified social credit code, business type, business term, staff size, registered address, business scope, and other information. At the same time, it provides dimensional data related to the enterprise, such as: industrial and commercial registered shareholders, key personnel in industrial and commercial registration, the company's foreign investment, change records, control companies, branches, head offices, contact numbers, contact emails and other information. Let you get all the information of the enterprise with only one query.",
    court_notice_info_description:
      "Description: Obtain the historical court announcement information of the queried company by searching keywords, and return the historical case number, announcement type, announcement person, plaintiff, defendant and other information.",
    corporate_news_search_description:
      "Description: Get the company's own news and public opinion, and through the intelligent data analysis of Qichacha, distinguish the emotional type of the news, and return fields such as the title, source, and category of the news.",

    fuzzy_search_cn: "Fuzzy company search",
    fuzzy_search_description:
      "Description: Obtain the list of companies that match the search criteria by searching for keywords (such as company name, person name, product name, address, phone number, business scope, etc.) Date, unified social credit code, registration number and other information.",
    fuzzy_search_cn_KeyNo: "KeyNo",
    fuzzy_search_cn_Name: "Name",
    fuzzy_search_cn_CreditCode: "Credit Code",
    fuzzy_search_cn_StartDate: "Start Date",
    fuzzy_search_cn_OperName: "Legal Representative",
    fuzzy_search_cn_Status: "Status",
    fuzzy_search_cn_No: "Registration number",
    fuzzy_search_cn_Address: "Registered address",

    province_code_keyWord: "Province code",
    city_code_keyword: "City code",
    data_is_not_found: "Data for service {x} by parameter {y} was not found",
    error_loading_service: "Error loading service {} by parameter ",

    common_info_Name: "Company Name",
    common_info_OperName: "Representative",
    common_info_Status: "Status",
    common_info_StartDate: "Date of establishment",
    common_info_RegistCapi: "Registered capital",
    common_info_RecCap: "Paid-up capital",

    common_info_CheckDate: "Approval date",
    common_info_OrgNo: "Organization code",
    common_info_No: "Business registration number",
    common_info_CreditCode: "Credit Code",
    common_info_EconKind: "Type of enterprise",
    common_info_TermStart: "Beginning date of the business",
    common_info_TermEnd: "End date of the business",
    common_info_TaxpayerType: "Taxpayer Type",
    common_info_BelongOrg: "Registration authority",
    common_info_PersonScope: "Staff size",
    common_info_InsuredCount: "Number of participants",
    common_info_EnglishName: "English name",
    common_info_IXCode: "Import and Export enterprise code",
    common_info_Address: "Address",
    common_info_Scope: "Scope",
    common_info_IsOnStock: "Is listed",
    common_info_StockNumber: "Stock code",
    common_info_StockType: "Type of listing",
    common_info_ImageUrl: "Logo",
    common_info_PhoneNumber: "Phone number",
    common_info_Email: "Email",
    common_info_WebSiteUrl: "Website Url",
    common_info_EntNature: "Enterprise nature",
    common_info_AreaCode: "Area Code",
    common_info_Industry: "Industry",
    common_info_UpdatedDate: "Updated date",
    common_info_EndDate: "Date of revocation",
    search_keyword_886:
      "Search keywords (such as company name, person name, product name, address, telephone, business scope, etc.)",
    group_request: "Group request",
    service_430: "Company information",
    service_930: "Court Notice Verification",
    service_701: "Corporate News Search",
    service_213: "Annual Report",
    service_736: "Enterprise Risk Scan",
    service_886: "Fuzzy company search",
    service_410: "Company search",
    service_410_admin: "Company search",
    service_736_213: "Short business reference",

    description_430:
      "Description: The interface covers business-to-business face-to-face information, such as business name, registration status, registered capital, unified social credit code, business type, business term, staff size, registered address, business scope, and other information. At the same time, it provides dimensional data related to the enterprise, such as: industrial and commercial registered shareholders, key personnel in industrial and commercial registration, the company's foreign investment, change records, control companies, branches, head offices, contact numbers, contact emails and other information. Let you get all the information of the enterprise with only one query.",
    description_930:
      "Description: Obtain the historical court announcement information of the queried company by searching keywords, and return the historical case number, announcement type, announcement person, plaintiff, defendant and other information.",
    description_701:
      "Description: Get the company's own news and public opinion, and through the intelligent data analysis of Qichacha, distinguish the emotional type of the news, and return fields such as the title, source, and category of the news.",
    description_213:
      "Description: The current interface includes both business information (including business interviews, shareholder information (including share ratio), key personnel, branches, change information, industry classification, corporate portraits, etc.), as well as corporate risk-related information, such as administrative Punishment, abnormal business operations, dishonesty persons subject to execution, persons subject to execution, chattel mortgage, liquidation, equity pledge, random inspection, tax credit and other information. Comprehensive dimension query allows you to obtain all the information of the enterprise in one query.",
    description_736:
      "Description: The current interface includes both business information (including business interviews, shareholder information (including share ratio), key personnel, branches, change information, industry classification, corporate portraits, etc.), as well as corporate risk-related information, such as administrative Punishment, abnormal business operations, dishonesty persons subject to execution, persons subject to execution, chattel mortgage, liquidation, equity pledge, random inspection, tax credit and other information. Comprehensive dimension query allows you to obtain all the information of the enterprise in one query.",
    description_886:
      "Description: Obtain the list of companies that match the search criteria by searching for keywords (such as company name, person name, product name, address, phone number, business scope, etc.) Date, unified social credit code, registration number and other information.",

    services_loading: "is loading",
    services_loading_data: "Loading data",
    services_loading_translations:
      "Loading translations. Translations can take some time, please don't close the window",
    services_rendering: "Rendering results",

    area_list_Province: "Province",
    area_list_City: "City",
    area_list_County: "District",

    industry_list_IndustryCode: "Industry Code",
    industry_list_Industry: "Industry Category description",
    industry_list_SubIndustryCode: "Industry Code",
    industry_list_SubIndustry: "Industry Category description",
    industry_list_MiddleCategoryCode: "Industry class code",
    industry_list_MiddleCategory: "Industry class description",
    industry_list_SmallCategoryCode: "Industry code",
    industry_list_SmallCategory: "Industry sub-category description",

    revoke_info_list_CancelDate: "Date of cancellation",
    revoke_info_list_CancelReason: "Reason of cancellation",
    revoke_info_list_RevokeDate: "Revocation date",
    revoke_info_list_RevokeReason: "Revocation for revocation",

    parent_info_list_KeyNo: "Enterprise Number",
    parent_info_list_Name: "Company Name",
    parent_info_list_OperName: "Representative",
    parent_info_list_RegistCapi: "Registered capital",
    parent_info_list_StartDate: "Date of establishment",
    parent_info_list_Status: "Status",

    visit_company_website: "Visit company's Website",
    // search_keyword_placeholder: "Keyword",
    search_keyword_placeholder: "Company title, name, product, address",
    bn_search_keyword_placeholder: "Social credit code, registration code",
    ca_search_keyword_placeholder: "Input name of counterparty for monitoring",
    search_parameters: "Parameters",

    history_results_not_found: "This service request had no matches",

    services_parameter_translation:
      "Search parameters are translating to English",

    fuzzy_load_more_results: "Load {} more records",

    search_parameters_translation:
      "Do you agree the parameters of your search would be translated to English? Translation: ",
    buyer: "Buyer",
    seller: "Seller",
    product: "Product",
    payment: "Payment",
    courier: "Carrier",
    actions: "",
    product_title: "Product Name",
    product_sku: "SKU",
    product_qty: "Quantity",
    product_ved: "FEA code",
    product_units: "Units",
    product_unit_price: "Price",
    conditions: "Conditions",
    term: "Delivery times",
    is_public: "Public contract",
    submit_button: "Save contract",
    add_form: "Form a new contract",
    current_contracts: "Contracts",
    products: "Products",
    add_product: "Add product",
    number_of_items: "Qty of items",
    group_search: "Business reference",

    info_1:
      "Get useful information about the company - basic information, information about the company`s annual report, court notices, corporate risk scans, etc.",
    info_2: "The query can be written in any language",
    info_3:
      "The cost of one request is 1500 rubles, for clients of Asia-Pacific Bank (JSC) a special rate - 1000 rubles for one request",
    info_4:
      "The cost of one request is 50 rubles, for clients of Asia-Pacific Bank (JSC) a special rate - 25 rubles per request",
    info_5:
      "Search counterparty / partner - registered users of the platform have the ability to search for foreign counterparties / partners to establish business relationships and transactions, as well as to send them commercial proposals",
    info_6: "This filter does not apply to sanctions lists and media mentions.",
    info_7:
      "Level of search flexibility (0% will only check for exact matches; 100% will search for results with even the slightest match in spelling and phonetics)",
    find_partner: "Partner Search",
    search_certificate: "Search certificate",
    search_query: "Search query",
    request_from: "Request from",
    request_date: "Date",
    no_matches_line: "Match status: no match",
    search_results: "Search results",
    found_matches: "Found matches",
    download_pdf: "Download PDF",
    download_pdf_no_logo: "Download PDF (No logo)",
    download_excel: "Download Excel",
    partner_search_excel_filename: "Counterparties in China",
    pdf_file_name: "Extended",
    pdf_short_file_name: "Short",
    pdf_company_info_service_cn: "Info",
    fuzzyness_no_results: "Fuzzyness",
    types_no_results: "Types",
    risk_level_no_results: "Risk Level",
    not_found_message:
      "company/person was not found on sanctions or other prohibition lists.",

    rating_410: "Rating",

    common_help_item_title: "Explanation",

    common_help_item_1: "The number of registered employees corresponds to the scale of the business",
    common_help_item_2: "What matters is not so much the registered capital as the paid-in capital",
    common_help_item_3: "The company's capital corresponds to the scale of the business and the field of activity (a requirement of PRC legislation)",
    common_help_item_4: "Empty tables, help sections without content, and missing items indicate that the activities of the reviewed company do not concern these items",
    common_help_item_5: "Some tables, due to a large number of fields, are carried over to the following lines",
    common_help_item_6: "The 'Record Change Information' table contains the chronology of the company's development (in the Extended version of the Help)",

    specific_help_items_title: "Explanation of the values of some items in the help",
    entType_explanation_title: "Nature of the enterprise's activity",
    entType_explanation: "0-mainland enterprise, 1-social organization, 3-Hong Kong company, 4-government institution, 5-Taiwanese company, 6-fund, 7-hospital, 8-overseas company, 9-law firm, 10-school, 11-institutional agency",

    IXCode_explanation_title: "Enterprise Import-Export Code",
    IXCode_explanation: "Used to identify the company during import and export operations. This is a mandatory requirement for any company wishing to engage in international trade",

    permissionInfo_explanation_title: "Administrative Licensing",
    permissionInfo_explanation: "A legal authorization by an administrative subject to a specific administrative counterparty to engage in certain activities or perform certain behaviors through the issuance of permits or licenses based on the application of the administrative counterparty in circumstances that are generally prohibited by law. An administrative action of rights or qualifications. This concept contains three meanings: firstly, there is a general legal prohibition; secondly, the administrative subject lifts the general prohibition from the counterparty; thirdly, the administrative counterparty obtains the qualification or right to engage in certain activities or perform certain behaviors",

    exceptions_explanation_title: "Abnormal Business Operations (Inclusion in the Register)",
    exceptions_explanation: "In accordance with legislation, restricts or prohibits government procurement, project bidding, transfer of state land, and cancels honorary titles. The credit restriction mechanism will affect bank credit, contract signing, customs clearance, obtaining work certificates for foreign corporate employees, etc.",

    spec_info_report_explanation_title: "Specificities of obtaining information from the annual report of chinese companies",
    spec_info_report_explanation: "All Chinese enterprises are required to submit an annual report to the regulatory authority, otherwise the company is entered into the register of \"Abnormal Business Operations\" (see above). At the same time, enterprises have the right not to disclose the report data publicly, but are required to provide the opportunity to obtain information from the latest annual report on an individual basis. The address at which the report can be obtained is displayed in the Contact information for receiving the latest corporate annual report subsection."
  },
  // Company Historical Sales (1105)
  company_history_sales: {
    company_historical_sales: "Company Historical Sales",
    search_button: "Search",
    select_month: "Select date",
    search_keyword_placeholder: "Unified Social Credit Code, Company Name",
    searching: "Searching",
    no_results_found: "No results found",
    month: "Month",
    year: "Year",
    company_name: "Company Name",
    sales_amount: "Monthly Sales Amount",
    yoy_percent: "YoY (%)",
    year_total: "Year Cumulative Sales",
    history: "History",
    fill_all_fields: "Complete All Fields",
    cn_single_service_alert: "Attention! {} is a paid service. The price is ",
    services_loading_data: "Loading data",
    services_loading_translations: "Loading translations. Translations can take some time, please don't close the window",
    error_loading_service: "Error loading service {} by parameter ",
    no_data_to_export: "No data to export",
    credit_code: "Unified Social Credit Code",
    sales_volume: "Monthly Sales Volume (10k pcs)",
    sales_volume_yoy: "Monthly Sales Volume YoY (%)",
    sales_amount_yoy: "Monthly Sales Amount YoY (%)",
    sales_volume_sum: "Year Cumulative Sales Volume (10k pcs)",
    sales_amount_sum: "Year Cumulative Sales Amount (10k RMB)",
    sales_volume_sum_yoy: "Cumulative Sales Volume YoY (%)",
    sales_amount_sum_yoy: "Cumulative Sales Amount YoY (%)",
    chart_title: "Cumulative Sales Amount by Month"
  },
  find_person: {
    title: "Find Person",
    search: "Search",
    search_name_placeholder: "Full name",
    search_id_placeholder: "Person ID",
    search_type_placeholder: "Type",
    searching: "Searching",
    no_results: "No results found",
    results_exists_by_response_code: "is a citizen of China. No negative information found.",
    history: "History",
    order_detail: "Detail",
    results: "Results",
    view: "View",
    search_name: "Search name",
    search_id_number: "Search ID Number",
    search_type: "Search Type",
    results_count: "Results Count",
    results_score: "Score",
    results_type: {
      "0-20": "",
      "20-30": "Wanted",
      "30-40": "Drugs",
      "40-50": "Drug Involvement",
      "50-60": "Criminal History",
      "60": "People with mental illness, protesters, terrorists and others",
      "60-100": "Not included in the category",
    },
    billing: {
      price: "Price",
      your_balance: "Your balance",
      not_enough_funds: "Not enough funds",
      not_enough_funds_history:
        "This history detail information was not bought. And you have not enough funds to buy it.",
      not_enough_funds_search:
        "You have not enough funds to search/buy this information.",
      buy_search: "Buy & Search?",
      buy_search_history:
        "This history detail information was not bought. Do you want to buy it?",
      search_buy: "Do you want to search/buy this information?",
    },
    types: {
      listOf: "List of",
      all: "All types",
      cpws: "Court document",
      ktgg: "Announcements of court hearings",
      zxgg: "Announcements of execution",
      shixin: "Announcements of non-trust",
      fygg: "Court announcement",
      ajlc: "Judicial process",
      bgt: "Publicity",
      sifacdk: "Detection, freezing and arrest",
      pmgg: "Auction sale notice",
    },
    vocabulary: {
      cpwsId: "Court Document ID",
      body: "Content",
      caseNo: "Case number",
      court: "Court",
      judge: "Judge",
      judgeResult: "Result of the court decision",
      sortTime: "Case completion date",
      title: "Heading",
      yiju: "Base",
      partys: "Parties",
      datatype: "Data type",
      birthday: "Date of birth of the party",
      caf: "Case fee",
      caseCauseT: "Main content of the case",
      caseNoKwordT: "Code value",
      caseTypeT: "Document type",
      courtRankT: "Court level",
      courtTypeT: "Vessel type",
      lawOffice: "Law office",
      lawyer: "Lawyer (defender)",
      partyFeeT: "Decision amount",
      partyPositionT: "Position of the party in court (first instance)",
      partyResultT: "Side result",
      partyTitleT: "Current status",
      partyType: "Side type",
      pname: "Party name",
      boHui: "Failure label",
      cdk: "Inspection, freezing, seizure mark",
      chaiChu: "Disable Mark",
      cheSu: "Dismissal label",
      diaoXiao: "Revocation label",
      faKuan: "Penalty mark",
      guoHu: "Re-registration label",
      jieChuCDK: "Label for cancellation of inspection, freezing, withdrawal",
      jingGao: "Warning label",
      juLiu: "Detention mark",
      moShou: "Seizure Mark",
      piaoJuWX: "Securities invalidation mark",
      poChanCZ: "Bankruptcy reorganization label",
      pochanHJ: "Bankruptcy Settlement Label",
      poChanQS: "Bankruptcy liquidation label",
      qangZhi: "Enforcement Label",
      qangZhiZX: "Forced Cancellation Label",
      qianChu: "Relocation Mark",
      queRenWF: "Illegality mark",
      queRenWX: "Invalidation mark",
      shiXin: "Loss of Trust Mark",
      tingChanTY: "Suspended production mark",
      zhongBen: "Marker for completion of the current executive procedure",
      zhongZhi: "Suspend label",
      zjzx: "Execution completion mark",
      signalDesc: "Signal Description",
      signalRating: "Signal level",
      signalRuleNo: "Rule code",
      signalRuleVersion: "Rule version",
      ruleMainType: "Main category",
      ruleSubType: "Subcategory",
      shixinId: "ID Notifications of mistrust",
      body: "Content",
      caseNo: "Case number",
      court: "Court name",
      postTime: "Publication date",
      sortTime: "Date of registration of the case",
      yiwu: "Responsibilities",
      yjCode: "Foundation document number",
      yjdw: "Organization that provided the basis",
      partys: "Parties",
      datatype: "Data type",
      age: "Age",
      caseNoKwordT: "Case number keyword",
      idcardNo: "ID number",
      jtqx: "Specific situation",
      lxqkT: "Execution Status",
      money: "Amount associated with the case",
      partyType: "Side type",
      pname: "Party name",
      province: "Provinces",
      signalDesc: "Signal Description",
      signalRating: "Signal level",
      signalRuleNo: "Rule code",
      signalRuleVersion: "Rule version",
      ruleMainType: "Main category",
      ruleSubType: "Subcategory",
      zxggId: "ID Notice of Execution",
      address: "Address",
      body: "Content",
      caseNo: "Case number",
      closeDate: "Case completion date",
      court: "Court name",
      proposer: "Applicant",
      sortTime: "Date of registration of the case",
      title: "Heading",
      yjCode: "Foundation document number",
      yjdw: "Organization that provided the basis",
      partys: "Parties",
      datatype: "Data type",
      caseStateT: "Case status",
      caseNoKwordT: "Case number keyword",
      execMoney: "Execution amount",
      idcardNo: "ID number",
      partyType: "Side type",
      pname: "Party name",
      signalDesc: "Signal Description",
      signalRating: "Signal level",
      signalRuleNo: "Rule code",
      signalRuleVersion: "Rule version",
      ruleMainType: "Main category",
      ruleSubType: "Subcategory",
      ktggId: "ID of the notice of court hearing",
      body: "Content",
      caseNo: "Case number",
      court: "Court",
      courtroom: "Courtroom",
      judge: "Judge",
      organizer: "Organizer",
      sortTime: "Meeting time",
      title: "Heading",
      partys: "Parties",
      datatype: "Data type",
      caseCauseT: "Main content of the case",
      caseNoKwordT: "Case number",
      courtRankT: "Court level",
      courtTypeT: "Vessel type",
      partyPositionT: "Position in the trial (first instance)",
      partyTitleT: "Current status",
      partyType: "Subject type",
      pname: "Participant name",
      signalDesc: "Signal Description",
      signalRating: "Signal level",
      signalRuleNo: "Rule code",
      signalRuleVersion: "Rule version",
      ruleMainType: "Main category",
      ruleSubType: "Subcategory",
      ajlcId: "Case process ID",
      actionObject: "Subject of the claim",
      body: "Content",
      caseNo: "Case number",
      courtS: "Court",
      organizer: "Organizer",
      sortTime: "Business time",
      title: "Heading",
      partys: "Participants",
      datatype: "Data type",
      ajlcStatusT: "Case status",
      caseCauseT: "Main content of the case",
      caseNoKwordT: "Case code",
      courtRankT: "Court level",
      courtTypeT: "Vessel type",
      partyPositionT: "Participant's position (first instance)",
      partyTitleT: "Current status",
      partyType: "Subject type",
      pname: "Participant name",
      trialProcedure: "Review status",
      signalDesc: "Signal Description",
      signalRating: "Signal level",
      signalRuleNo: "Rule code",
      signalRuleVersion: "Rule version",
      ruleMainType: "Main category",
      ruleSubType: "Subcategory",
      body: "Content",
      caseNo: "Case number",
      court: "Court name",
      dataType: "Data type",
      fyggId: "Judicial announcement ID",
      layout: "Layout",
      partys: "Participants",
      sortTime: "Time to file a case",
      title: "Heading",
      caseCauseT: "Main content of the case",
      caseNoKwordT: "Case code",
      courtRankT: "Court level",
      courtTypeT: "Vessel type",
      ggTypeT: "Ad type",
      partyPositionT: "Participant's position (first instance)",
      partyTitleT: "Current status",
      partyType: "Subject type",
      pname: "Participant name",
      ruleMainType: "Basic type",
      ruleSubType: "Subtype",
      signalDesc: "Signal Description",
      signalRating: "Signal level",
      signalRuleNo: "Rule code",
      signalRuleVersion: "Rule version",
      bgtId: "Publication platform ID",
      body: "Content",
      caseNo: "Case number",
      court: "Court name",
      proposer: "Applicant",
      sortTime: "Time to file a case",
      title: "Heading",
      yiju: "Base",
      yjCode: "Base code",
      partys: "Participants",
      address: "Address",
      caseCauseT: "Main content of the case",
      caseNoKwordT: "Case code",
      execMoney: "Amount of claim",
      idcardNo: "ID number",
      partyType: "Subject type",
      pname: "Participant name",
      signalDesc: "Signal Description",
      signalRating: "Signal level",
      signalRuleNo: "Rule code",
      signalRuleVersion: "Rule version",
      ruleMainType: "Basic type",
      ruleSubType: "Subtype",
      sifacdkId: "ID of judicial discovery, freezing and seizure",
      body: "Content",
      sortTime: "Review time",
      eventDate: "Event date",
      objectName: "Object name",
      court: "Court",
      pname: "Participant",
      title: "Heading",
      action: "Asset category",
      caseNo: "Case number",
      objectType: "Object type",
      postTime: "Publication time",
      money: "Amount (in RMB)",
      dataType: "Data type",
      pmggId: "Auction ad ID",
      title: "Sale ad title",
      pname: "Auction object owner",
      idCardNo: "Owner's ID number",
      address: "Detailed address of the object",
      auctionAmount: "Initial price of the object",
      auctionType: "Object type",
      lot: "name of the property",
      lotInfo: "Detailed description of the object",
      powerNo: "Number of the legal document for the object",
      measure: "Object area",
      postTime: "Publication date",
      sortTime: "Auction date",
      court: "Court executing the sale",
      body: "Source code | Content",
      dataType: "Data type",
    },
  },
  risk_control: {
    title: "Risk Control",
    search: "Search",
    search_keyword_placeholder: "Social credit code, registration code",
    searching: "Searching",
    no_results: "No Results Found",
    history: "History",
    search_input: "Search Keyword",
    view: "View",
    billing: {
      price: "Price",
      your_balance: "Your balance",
      not_enough_funds: "Not enough funds",
      not_enough_funds_search:
        "You have not enough funds to search/buy this information.",
      buy_search: "Buy & Search?",
      search_buy: "Do you want to search/buy this information?",
    },
    vocabulary: {
      KeyNo: "Key No",
      Name: "Name",
      CreditCode: "Credit Code",
      OperName: "Oper Name",
      Status: "Status",
      StartDate: "Start Date",
      RegistCapi: "Regist Capi",
      RealCapi: "Real Capi",
      OrgNo: "Org No",
      No: "No",
      TaxNo: "Tax No",
      EconKind: "Econ Kind",
      TermStart: "Term Start",
      TermEnd: "Term End",
      TaxpayerType: "Taxpayer Type",
      PersonScope: "Person Scope",
      InsuredCount: "Insured Count",
      CheckDate: "Check Date",
      AreaCode: "Area Code",
      Area: "Area",
      Province: "Province",
      City: "City",
      County: "County",
      BelongOrg: "Belong Org",
      ImExCode: "Im Ex Code",
      Industry: "Industry",
      IndustryCode: "Industry Code",
      SubIndustryCode: "Sub Industry Code",
      SubIndustry: "Sub Industry",
      MiddleCategoryCode: "Middle Category Code",
      MiddleCategory: "Middle Category",
      SmallCategoryCode: "Small Category Code",
      SmallCategory: "Small Category",
      EnglishName: "English Name",
      Address: "Address",
      AnnualAddress: "Annual Address",
      Scope: "Scope",
      EntType: "Ent Type",
      ImageUrl: "Image Url",
      RevokeInfo: "Revoke Info",
      OriginalName: "Original Name",
      ChangeDate: "Change Date",
      StockInfo: "Stock Info",
      ContactInfo: "Contact Info",
      WebSiteList: "Web Site List",
      Email: "Email",
      MoreEmailList: "More Email List",
      Source: "Source",
      Tel: "Tel",
      MoreTelList: "More Tel List",
      LongLat: "Long Lat",
      Longitude: "Longitude",
      Latitude: "Latitude",
      BankInfo: "Bank Info",
      Bank: "Bank",
      BankAccount: "Bank Account",
      IsSmall: "Is Small",
      Scale: "Scale",
      QccIndustry: "Qcc Industry",
      AName: "A Name",
      BName: "B Name",
      CName: "C Name",
      DName: "D Name",
      IsOfficialEnglish: "Is Official English",
      PartnerList: "Partner List",
      StockName: "Stock Name",
      StockType: "Stock Type",
      StockPercent: "Stock Percent",
      ShouldCapi: "Should Capi",
      ShoudDate: "Shoud Date",
      StakeDate: "Stake Date",
      PubPartnerList: "Pub Partner List",
      EmployeeList: "Employee List",
      Job: "Job",
      PubEmployeeList: "Pub Employee List",
      BranchList: "Branch List",
      ChangeList: "Change List",
      ProjectName: "Project Name",
      BeforeList: "Before List",
      AfterList: "After List",
      TagList: "Tag List",
      Type: "Type",
      Parent: "Parent",
      Beneficiary: "Beneficiary",
      ActualControllerList: "Actual Controller List",
      FinalBenefitPercent: "Final Benefit Percent",
      ControlPercent: "Control Percent",
      IsActual: "Is Actual",
      EmergingIndustyList: "Emerging Industy List",
      PrimaryCode: "Primary Code",
      PrimaryDes: "Primary Des",
      SecondaryList: "Secondary List",
      SecondaryCode: "Secondary Code",
      SecondaryDes: "Secondary Des",
      TertiaryList: "Tertiary List",
      TertiaryCode: "Tertiary Code",
      TertiaryDes: "Tertiary Des",
      GroupInfo: "Group Info",
      GroupId: "Group Id",
      Logo: "Logo",
      InvestmentList: "Investment List",
      FundedRatio: "Funded Ratio",
      ProductList: "Product List",
      RoundDesc: "Round Desc",
      Location: "Location",
      Description: "Description",
      AdminLicenseList: "Admin License List",
      LicensDocNo: "Licens Doc No",
      LicensDocName: "Licens Doc Name",
      ValidityFrom: "Validity From",
      ValidityTo: "Validity To",
      LicensOffice: "Licens Office",
      LicensContent: "Licens Content",
      ApproveSiteList: "Approve Site List",
      WebAddress: "Web Address",
      DomainName: "Domain Name",
      LesenceNo: "Lesence No",
      AuditDate: "Audit Date",
      SpotCheckList: "Spot Check List",
      ExecutiveOrg: "Executive Org",
      Date: "Date",
      Consequence: "Consequence",
      TaxCreditList: "Tax Credit List",
      Year: "Year",
      Level: "Level",
      Org: "Org",
      ShiXin: "Shi Xin",
      ZhiXing: "Zhi Xing",
      AdminPenalty: "Admin Penalty",
      Exception: "Exception",
      ChattelMortgage: "Chattel Mortgage",
      Liquidation: "Liquidation",
      EquityPledge: "Equity Pledge",
      SeriousIllegal: "Serious Illegal",
      EquityFreeze: "Equity Freeze",
      JudicialSale: "Judicial Sale",
      Bankruptcy: "Bankruptcy",
      Sumptuary: "Sumptuary",
      EnvPunishment: "Env Punishment",
      TaxOweNotice: "Tax Owe Notice",
      TaxIllegal: "Tax Illegal",
      TaxAbnormal: "Tax Abnormal",
    },
  },
  business_score: {
    title: "Business Score",
    search: "Search",
    search_keyword_placeholder: "Social credit code, registration code",
    searching: "Searching",
    no_results: "No Results Found",
    history: "History",
    search_input: "Search Keyword",
    view: "View",
    language: "Language",
    year: "Year",
    vocabulary: {
      year: "Year",
      totalAsset: "Total Asset",
      totalEquity: "Total Equity",
      totalSale: "Total Sales",
      primarySale: "Primary Sales",
      netProfits: "Net Profit",
      totalProfits: "Total Profit",
      totalTax: "Total Tax",
      totalLiability: "Total Liability",
      tel: "Telephone",
      postalcode: "Postal Code",
      dom: "Domicile",
      email: "Email",
    }
  },
  case_filling_info: {
    title: "Case Filling Information",
    search: "Search",
    search_keyword_placeholder: "Social credit code, registration code",
    searching: "Searching",
    no_results: "No Results Found",
    history: "History",
    search_input: "Search Keyword",
    view: "View",
    page: "Page",
    date: "Date",
    next: "Next",
    back: "Back",
    vocabulary: {
      court: "Court",
      punish_date: "Punish Date",
      case_reason: "Case Reason",
      prosecutors: "Prosecutors",
      defendants: "Defendants",
      search_type: "Search by",
      defendant: "Defendant",
      prosecutor: "Prosecutor"
    }
  },
  contragent_search: {
    date: "Date",
    search_text: "Search request",
    service_code: "Service name",
    do_bulk: "Bulk request",
    annual_report_description:
      "Description: The company's annual report includes the basic information declared by the company itself, website or online store information, sponsor and capital contribution information, corporate asset status and equity change information, etc.",
    enterprise_risk_scan_description:
      "Description: The current interface includes both business information (including business interviews, shareholder information (including share ratio), key personnel, branches, change information, industry classification, corporate portraits, etc.), as well as corporate risk-related information, such as administrative Punishment, abnormal business operations, dishonesty persons subject to execution, persons subject to execution, chattel mortgage, liquidation, equity pledge, random inspection, tax credit and other information. Comprehensive dimension query allows you to obtain all the information of the enterprise in one query.",
    annual_report: "Annual Report",
    annual_report_no_logo: "Annual Report (No logo)",
    enterprise_risk_scan: "Enterprise Risk Scan",
    enterprise_risk_scan_no_logo: "Enterprise Risk Scan (No logo)",
    enterprise_basic_information: "Enterprise Basic Information",
    AssetsData: "Assets Data",
    SocialInsurance: "Social Insurance",
    BasicInfo: "Basic Info",
    ChangeList: "Change List",
    InvestInfoList: "Invest Info List",
    PartnerList: "Partner List",
    ProvideAssuranceList: "Provide Assurance List",
    StockChangeList: "Stock Change List",
    WebSiteList: "Web Site List",
    AdministrationLicenseList: "Administration License List",
    BranchList: "Branch List",
    EmployeeList: "Employee List",
    No: "No",
    Year: "Year",
    PublishDate: "Publish Date",
    TotalAssets: "Total Assets",
    TotalOwnersEquity: "Total Owners Equity",
    GrossTradingIncome: "Gross Trading Income",
    MainBusinessIncome: "Main Business Income",
    NetProfit: "Net Profit",
    TotalTaxAmount: "Total Tax Amount",
    TotalLiabilities: "Total Liabilities",
    BankingCredit: "Banking Credit",
    GovernmentSubsidy: "Government Subsidy",
    UrbanBasicIns: "Urban Basic Ins",
    EmployeeBasicIns: "Employee Basic Ins",
    MaternityIns: "Maternity Ins",
    UnemploymentIns: "Unemployment Ins",
    IndustrialInjuryIns: "Industrial Injury Ins",
    EntUrbanBasicInsNum: "Ent Urban Basic Ins Num",
    EntUnemploymentInsNum: "Ent Unemployment Ins Num",
    EntEmployeeBasicInsNum: "Ent Employee Basic Ins Num",
    EntIndustrialInjuryInsNum: "Ent Industrial Injury Ins Num",
    EntMaternityInsNum: "Ent Maternity Ins Num",
    ActUrbanBasicInsAmount: "Act Urban Basic Ins Amount",
    ActUnemploymentInsAmount: "Act Unemployment Ins Amount",
    ActEmployeeBasicInsAmount: "Act Employee Basic Ins Amount",
    ActIndustrialInjuryInsAmount: "Act Industrial Injury Ins Amount",
    ActMaternityInsAmount: "Act Maternity Ins Amount",
    OweUrbanBasicInsAmount: "Owe Urban Basic Ins Amount",
    OweUnemploymentInsAmount: "Owe Unemployment Ins Amount",
    OweIndustrialInjuryInsAmount: "Owe Industrial Injury Ins Amount",
    OweMaternityInsAmount: "Owe Maternity Ins Amount",
    RegNo: "Reg No",
    CompanyName: "Company  Name",
    CreditCode: "Credit Code",
    OperatorName: "Operator Name",
    ContactNo: "Contact No",
    PostCode: "Post Code",
    Address: "Address",
    EmailAddress: "Email Address",
    IsStockRightTransfer: "Is Stock Right Transfer",
    Status: "Status",
    HasWebSite: "Has Web Site",
    HasNewStockOrByStock: "Has New Stock Or By Stock",
    EmployeeCount: "Employee Count",
    BelongTo: "Belong To",
    CapitalAmount: "Capital Amount",
    HasProvideAssurance: "Has Provide Assurance",
    OperationPlaces: "Operation Places",
    MainType: "Main Type",
    OperationDuration: "Operation Duration",
    IfContentSame: "If Content Same",
    DifferentContent: "Different Content",
    GeneralOperationItem: "General Operation Item",
    ApprovedOperationItem: "Approved Operation Item",
    No: "No",
    ChangeName: "Change Name",
    Before: "Before",
    After: "After",
    ChangeDate: "Change Date",
    Name: "Name",
    ShouldCapi: "Should Capi",
    ShouldDate: "Should Date",
    ShouldType: "Should Type",
    RealCapi: "Real Capi",
    RealDate: "Real Date",
    RealType: "Real Type",
    Form: "Form",
    InvestmentRatio: "Investment Ratio",
    KeyNo: "Key No",
    ShareholdingRatio: "Shareholding Ratio",
    Creditor: "Creditor",
    Debtor: "Debtor",
    CreditorCategory: "Creditor Category",
    CreditorAmount: "Creditor Amount",
    FulfillObligation: "Fulfill Obligation",
    AssuranceDurn: "Assurance Durn",
    AssuranceType: "Assurance Type",
    AssuranceScope: "Assurance Scope",
    Type: "Type",
    WebSite: "Web Site",
    EndDate: "End Date",
    principal: "principal",
    Job: "Job",
    CerNo: "Cer No",
    ScertName: "Scert Name",
    ers_AreaCode: "Area Code",
    ers_RecCap: "Rec Cap",
    ers_EntType: "Ent Type",
    ers_ImageUrl: "Image Url",
    ers_StockType: "Stock Type",
    ers_StockNumber: "Stock Number",
    ers_IsOnStock: "Is On Stock",
    ers_OrgNo: "Org No",
    ers_CheckDate: "Check Date",
    ers_TeamEnd: "Team End",
    ers_TermStart: "Term Start",
    ers_Scope: "Scope",
    ers_Address: "Address",
    ers_EconKind: "Econ Kind",
    ers_RegistCapi: "Regist Capi",
    ers_CreditCode: "Credit Code",
    ers_UpdatedDate: "Updated Date",
    ers_Province: "Province",
    ers_Status: "Status",
    ers_EndDate: "End Date",
    ers_StartDate: "Start Date",
    ers_OperName: "Oper Name",
    ers_OperId: "Oper Id",
    ers_BelongOrg: "Belong Org",
    ers_No: "No",
    ers_Name: "Name",
    ers_KeyNo: "Key No",
    ers_IXCode: "I X Code",
    ers_PersonScope: "Person Scope",
    ers_EnglishName: "English Name",
    ers_InsuredCount: "Insured Count",
    ers_pi_Name: "Name",
    ers_pi_Province: "Province",
    ers_pi_Liandate: "Liandate",
    ers_pi_CaseNo: "Case No",
    ers_pi_DocNo: "Doc No",
    ers_pi_PenaltyType: "Penalty Type",
    ers_pi_OfficeName: "Office Name",
    ers_pi_Content: "Content",
    ers_pi_PenaltyDate: "Penalty Date",
    ers_pi_PublicDate: "Public Date",
    ers_pi_Remark: "Remark",
    ers_pi_AddReason: "Add Reason",
    ers_pi_AddDate: "Add Date",
    ers_pi_RomoveReason: "Romove Reason",
    ers_pi_RemoveDate: "Remove Date",
    ers_pi_DecisionOffice: "Decision Office",
    ers_pi_RemoveDecisionOffice: "Remove Decision Office",
    ers_pi_Anno: "Anno",
    ers_pi_Orgno: "Orgno",
    ers_pi_Execute: "Execute",
    ers_pi_Publicdate: "Publicdate",
    ers_pi_Executestatus: "Executestatus",
    ers_pi_Actionremark: "Actionremark",
    ers_pi_Executegov: "Executegov",
    ers_pi_Id: "Id",
    ers_pi_Sourceid: "Sourceid",
    ers_pi_ExecuteGov: "Execute Gov",
    ers_pi_Biaodi: "Biaodi",
    ers_pi_Status: "Status",
    ers_pi_PartyCardNum: "Party Card Num",
    ers_pi_Updatedate: "Updatedate",
    ers_pi_RegisterNo: "Register No",
    ers_pi_RegisterDate: "Register Date",
    ers_pi_RegisterOffice: "Register Office",
    ers_pi_DebtSecuredAmount: "Debt Secured Amount",
    ers_pi_Leader: "Leader",
    ers_pi_Member: "Member",
    ers_pi_CompanyId: "Company Id",
    ers_pi_RegistNo: "Regist No",
    ers_pi_Pledgor: "Pledgor",
    ers_pi_PledgorNo: "Pledgor No",
    ers_pi_Pledge: "Pledge",
    ers_pi_PledgeNo: "Pledge No",
    ers_pi_PledgedAmount: "Pledged Amount",
    ers_pi_RegDate: "Reg Date",
    ers_pi_No: "No",
    ers_pi_ExecutiveOrg: "Executive Org",
    ers_pi_Type: "Type",
    ers_pi_Date: "Date",
    ers_pi_Consequence: "Consequence",
    ers_pi_Year: "Year",
    ers_pi_Level: "Level",
    ers_pi_CompanyName: "Company Name",
    ers_pi_Link: "Link",
    ers_pi_ImageUrl: "Image Url",
    ers_pi_Domain: "Domain",
    ers_pi_Tags: "Tags",
    ers_pi_Description: "Description",
    ers_pi_Category: "Category",
    ers_pi_LicensesDocNo: "Licenses Doc No",
    ers_pi_LicensesDocName: "Licenses Doc Name",
    ers_pi_ValidityFrom: "Validity From",
    ers_pi_ValidityTo: "Validity To",
    ers_pi_LicensOffice: "Licens Office",
    ers_pi_LicensesContent: "Licenses Content",
    ers_pi_OwnerName: "Owner Name",
    ers_pi_CaseReason: "Case Reason",
    ers_pi_KeyNo: "Key No",
    ers_pi_StockName: "Stock Name",
    ers_pi_StockType: "Stock Type",
    ers_pi_StockPercent: "Stock Percent",
    ers_pi_ShouldCapi: "Should Capi",
    ers_pi_ShouldDate: "Should Date",
    ers_pi_InvestType: "Invest Type",
    ers_pi_InvestName: "Invest Name",
    ers_pi_RealCapi: "Real Capi",
    ers_pi_CapiDate: "Capi Date",
    ers_pi_TagsList: "Tags List",
    ers_pi_FinalBenefitPercent: "Final Benefit Percent",
    ers_pi_RelatedProduct: "Related Product",
    ers_pi_RelatedOrg: "Related Org",
    ers_pi_Job: "Job",
    ers_pi_RegNo: "Reg No",
    ers_pi_BelongOrg: "Belong Org",
    ers_pi_CreditCode: "Credit Code",
    ers_pi_OperName: "Oper Name",
    ers_pi_ProjectName: "Project Name",
    ers_pi_BeforeContent: "Before Content",
    ers_pi_AfterContent: "After Content",
    ers_pi_ChangeDate: "Change Date",
    ers_pi_name: "name",
    ers_pi_WebSite: "Web Site",
    ers_pi_PhoneNumber: "Phone Number",
    ers_pi_Email: "Email",
    ers_pi_IndustryCode: "Industry Code",
    ers_pi_Industry: "Industry",
    ers_pi_SubIndustryCode: "Sub Industry Code",
    ers_pi_SubIndustry: "Sub Industry",
    ers_pi_MiddleCategoryCode: "Middle Category Code",
    ers_pi_MiddleCategory: "Middle Category",
    ers_pi_SmallCategoryCode: "Small Category Code",
    ers_pi_SmallCategory: "Small Category",
    ers_pi_ContactNo: "Contact No",
    ers_pi_EmailAddress: "Email Address",
    ers_pi_Address: "Address",
    ers_Liquidation: "Liquidation",
    ers_ContactInfo: "Contact Info",
    ers_Industry: "Industry",
    ers_Area: "Area",
    ers_area_Province: "Province",
    ers_area_City: "City",
    ers_area_County: "County",
    ers_rev_CancelDate: "Cancel Date",
    ers_rev_CancelReason: "Cancel Reason",
    ers_rev_RevokeDate: "Revoke Date",
    ers_rev_RevokeReason: "Revoke Reason",
    ers_RevokeInfo: "Revoke Info",
    ers_ind_IndustryCode: "Industry Code",
    ers_ind_Industry: "Industry",
    ers_ind_SubIndustryCode: "Sub Industry Code",
    ers_ind_SubIndustry: "Sub Industry",
    ers_ind_MiddleCategoryCode: "Middle Category Code",
    ers_ind_MiddleCategory: "Middle Category",
    ers_ind_SmallCategoryCode: "Small Category Code",
    ers_ind_SmallCategory: "Small Category",
    ers_PermissionInfo: "Permission Info",
    ers_Penalty: "Penalty",
    ers_Exceptions: "Exceptions",
    ers_ShiXinItems: "Shi Xin Items",
    ers_ZhiXingItems: "Zhi Xing Items",
    ers_MPledge: "M Pledge",
    ers_Pledge: "Pledge",
    ers_SpotCheck: "Spot Check",
    ers_CompanyTaxCreditItems: "Company Tax Credit Items",
    ers_CompanyProducts: "Company Products",
    ers_PermissionEciInfo: "Permission Eci Info",
    ers_PenaltyCreditChina: "Penalty Credit China",
    ers_Partners: "Partners",
    ers_Employees: "Employees",
    ers_Branches: "Branches",
    ers_ChangeRecords: "Change Records",
    ers_EmergingIndustyList: "Emerging Industy List",
    ers_TagList: "Tag List",
    ers_ARContactList: "A R Contact List",
    ers_OriginalName: "Original Name",

    company_info_status_1: "operating company",
    company_info_status_2: "does not operate at the address of registration",
    company_info_status_3: "cancellation of business status",
    company_info_status_4: "the company no longer exists",
    company_info_status_5: "suspended",
    company_info_status_6: "liquidated",
    TotalProfit: "Total profit",
  },
  atb_home: {
    price_description: "Cost of 1 request",
    service_price_for_privileged: "for ATB clients",

    service_monitoring_title:
      "Monitoring and verification of potential counterparties",
    service_monitoring_description:
      "<ul><li>Sanction Lists</li><li>Credit Bureau Reports</li><li>Securities Commission Reports</li><li>Exchanges</li></ul><p>Single verification or regular monitoring of legal entities and individuals in international databases:</p>",
    service_find_title: "Search for foreign counterparties",
    service_find_description:
      "<p>We will find for you contractors or business partners in China in the direction of business activities</p>",

    service_note_title: "Business reference about&nbsp;counterparty",
    service_note_description:
      "<ul><li>Background</li><li>Company Annual Report Information</li><li>Legal Notices</li><li>Corporate Risk Scan</li></ul>",

    banner_title: "Special conditions for&nbsp;ATB clients",
    banner_text:
      "Get 3000 welcome points.<br>Get special rates for ATTIS services",
    banner_button_1: "Become an ATB customer",
    banner_button_2: "About conditions",

    contact_form_title: "Feedback form",
    contact_form_subject: "Message subject",
    contact_form_name: "Your name",
    contact_form_email: "E-mail",
    contact_form_message: "Message>",
    contact_form_accept:
      "I express my consent to the processing and transfer of my personal data",
    contact_form_submit: "Submit",
    contact_form_submit_success: "Message sent",
    contact_form_submit_sending: "Submitting...",
    contact_form_subject_placeholder: "Specify the purpose of the request",
    contact_form_name_placeholder: "Full name",
    contact_form_email_placeholder: "E-mail",
    contact_form_message_placeholder: "Message text",

    footer_address: "630005, Novosibirsk, st. Nekrasova, 48, office 502",
  },
  kz_home: {
    footer_address:
      "010000, Astana city, Almaty district, avenue R. Koshkarbaeva 28, n.p. 10",
  },
  hypertable: {
    date_since: "Since",
    date_till: "till",
    or: "or",
    monthly_report: "Report per month",
    records_per_page: "Records per page",
    choose_month: "Choose month",
    year: "Year",
    month: "Month",
    show_report: "Generate report",
    month_0: "Jan",
    month_1: "Feb",
    month_2: "Mar",
    month_3: "Apr",
    month_4: "May",
    month_5: "Jun",
    month_6: "Jul",
    month_7: "Aug",
    month_8: "Sep",
    month_9: "Oct",
    month_10: "Nov",
    month_11: "Dec",
  },
  ng_login: {
    email_login: "E-mail address",
    password: "Password",
    forgot_password: "Forgot password",
    login_button: "Log in",
    register_button: "Registration",
  },
  ng_register: {
    choose_your_function: "Chose your function",
    choose: "Choose",
    submit: "Submit",
    please_enter_data_below: "Please, enter the data below",
    representative: "Representative",
    company: "Company",
    given_name: "Given Name",
    middle_name: "Middle Name",
    family_name: "Family Name",
    designation: "Designation",
    tin: "TIN",
    rc_number: "RC Number",
    company_name: "Company Name",
    state_code: "State Code",
    city: "City",
    address: "Address",
    phone: "Phone",
    fax: "Fax",
    email: "E-mail",
    password: "Password",
    confirm_password: "Confirm password",
    get_tin: "Get TIN Data",
    clear: "Clear",
    continue: "Continue",
    add_document: "Add document",
    reference_number: "Reference Number",
    document_date: "Date",
    upload: "Upload",
    uploading: "Uploading...",
    required_file: "It is necessary to attach a document",
    registration_successful: "User Registration Successful",
  },
  billing: {
    price: "Price",
    your_balance: "Your balance",
    not_enough_funds: "Not enough funds",
    not_enough_funds_search:
      "You have not enough funds to search/buy this information.",
    buy_search: "Buy & Search?",
    search_buy: "Do you want to search/buy this information?",
  },
  service_430: {
    KeyNo: "Key Number",
    Name: "Name",
    OperId: "Operator ID",
    OperName: "Operator Name",
    Status: "Status",
    StartDate: "Start Date",
    RegistCapi: "Registered Capital",
    RecCap: "Received Capital",
    CheckDate: "Check Date",
    OrgNo: "Organization Number",
    No: "Number",
    CreditCode: "Credit Code",
    EconKind: "Economic Kind",
    TermStart: "Term Start",
    TermEnd: "Term End",
    TaxpayerType: "Taxpayer Type",
    BelongOrg: "Belonging Organization",
    PersonScope: "Person Scope",
    InsuredCount: "Insured Count",
    EnglishName: "English Name",
    IXCode: "IX Code",
    Address: "Address",
    Scope: "Scope",
    IsOnStock: "Is On Stock",
    StockNumber: "Stock Number",
    StockType: "Stock Type",
    ImageUrl: "Image URL",
    PhoneNumber: "Phone Number",
    Email: "Email",
    WebSiteUrl: "Website URL",
    EntNature: "Enterprise Nature",
    AreaCode: "Area Code",
    RevokeInfo: "Revoke Information",
    ControlList: "Control List",
    ParentInfo: "Parent Information",
  },
  code_must_be_12_symbols: "Tax Code or Social Credit Code must be of 15 or 18 symbols",
  request_error_messages: {
    connection_issue_retrying: "Internet connection lost. Retrying.",
    connection_issue: "Internet connection lost.",
    connection_unstable: "Your internet connection is unstable. It may take a very long time to get results. Change your internet provider and try again."
  }
};
